var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg_({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241.69531pt",
    height: "603.73438pt",
    viewBox: "0 0 241.69531 603.73437",
    id: "svg1363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.75,4.59375 c -0.125,0.289062 -0.433594,0.4375 -0.921875,0.4375 -0.125,0 -0.257813,-0.023438 -0.390625,-0.0625 L 1.734375,4.78125 C 0.960938,4.582031 0.445312,4.175781 0.1875,3.5625 0.0625,3.257812 0,2.910156 0,2.515625 v -1.34375 c 0,-0.230469 0.113281,-0.34375 0.34375,-0.34375 0.238281,0 0.359375,0.113281 0.359375,0.34375 v 1.53125 C 0.703125,3.003906 0.800781,3.285156 1,3.546875 1.195312,3.816406 1.441406,3.988281 1.734375,4.0625 L 2.4375,4.25 c 0.144531,0.039062 0.273438,0.0625 0.390625,0.0625 0.4375,0 0.65625,-0.289062 0.65625,-0.859375 v -0.625 c 0,-0.242187 0.113281,-0.359375 0.34375,-0.359375 0.226563,0 0.34375,0.117188 0.34375,0.359375 v 0.8125 c 0,0.414063 0.171875,0.773437 0.515625,1.078125 C 4.851562,4.863281 5.03125,4.957031 5.21875,5 c 0.113281,0.03125 0.21875,0.046875 0.3125,0.046875 0.488281,0 0.734375,-0.28125 0.734375,-0.84375 V 2.84375 C 6.265625,2.613281 6.378906,2.5 6.609375,2.5 c 0.226563,0 0.34375,0.113281 0.34375,0.34375 v 1.546875 c 0,0.539063 -0.246094,0.9375 -0.734375,1.1875 C 6.007812,5.691406 5.785156,5.75 5.546875,5.75 5.429688,5.75 5.320312,5.738281 5.21875,5.71875 4.457031,5.519531 3.96875,5.144531 3.75,4.59375 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.703125,2.703125 c 0,0.71875 0.34375,1.171875 1.03125,1.359375 L 2.4375,4.25 c 0.132812,0.039062 0.265625,0.0625 0.390625,0.0625 0.4375,0 0.65625,-0.292969 0.65625,-0.875 V 2.359375 l -1.75,-0.453125 C 1.628906,1.875 1.546875,1.859375 1.484375,1.859375 1.242188,1.859375 1.050781,1.9375 0.90625,2.09375 0.769531,2.257812 0.703125,2.460938 0.703125,2.703125 Z M 0,2.515625 C 0,2.023438 0.253906,1.632812 0.765625,1.34375 c 0.21875,-0.136719 0.445313,-0.203125 0.6875,-0.203125 0.09375,0 0.1875,0.015625 0.28125,0.046875 L 3.828125,1.75 C 4.597656,1.945312 5.242188,2.289062 5.765625,2.78125 6.347656,3.332031 6.738281,4.046875 6.9375,4.921875 6.945312,4.941406 6.953125,4.96875 6.953125,5 c 0,0.238281 -0.117187,0.359375 -0.34375,0.359375 C 6.410156,5.359375 6.300781,5.28125 6.28125,5.125 6.226562,4.738281 6.082031,4.347656 5.84375,3.953125 5.414062,3.242188 4.859375,2.789062 4.171875,2.59375 V 3.640625 C 4.171875,4.035156 4.039062,4.363281 3.78125,4.625 3.53125,4.882812 3.207031,5.015625 2.8125,5.015625 2.675781,5.015625 2.550781,5 2.4375,4.96875 L 1.734375,4.78125 C 0.921875,4.5625 0.398438,4.171875 0.171875,3.609375 0.0546875,3.316406 0,2.953125 0,2.515625 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.421875,4.921875 0.15625,2.90625 C 0.0507812,2.84375 0,2.742188 0,2.609375 c 0,-0.09375 0.0351562,-0.179687 0.109375,-0.25 0.070313,-0.0625 0.15625,-0.09375 0.25,-0.09375 L 6.609375,2.5 c 0.226563,0 0.34375,0.113281 0.34375,0.34375 0,0.25 -0.121094,0.367188 -0.359375,0.359375 L 1.640625,3 4.703125,4.875 C 4.816406,4.9375 4.875,5.03125 4.875,5.15625 4.875,5.382812 4.765625,5.503906 4.546875,5.515625 L 1.59375,5.75 6.765625,8.296875 c 0.125,0.0625 0.1875,0.164063 0.1875,0.3125 0,0.226563 -0.117187,0.34375 -0.34375,0.34375 -0.054687,0 -0.105469,-0.011719 -0.15625,-0.03125 L 0.1875,5.8125 C 0.0625,5.75 0,5.648438 0,5.515625 0,5.285156 0.109375,5.164062 0.328125,5.15625 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.703125,4.046875 C 0.703125,4.285156 0.582031,4.40625 0.34375,4.40625 0.113281,4.40625 0,4.285156 0,4.046875 V 1.078125 C 0,0.972656 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.78125 0.34375,0.8125 L 6.6875,2.515625 c 0.175781,0.050781 0.265625,0.160156 0.265625,0.328125 0,0.238281 -0.117187,0.359375 -0.34375,0.359375 -0.042969,0 -0.074219,-0.00781 -0.09375,-0.015625 L 0.703125,1.625 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.484375,4.265625 V 2.375 L 0.703125,1.625 V 4.046875 C 0.703125,4.285156 0.582031,4.40625 0.34375,4.40625 0.113281,4.40625 0,4.285156 0,4.046875 V 1.078125 C 0,0.972656 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.78125 0.34375,0.8125 l 6.265625,1.671875 c 0.226563,0.0625 0.34375,0.21875 0.34375,0.46875 V 5.71875 c 0,0.238281 -0.117187,0.359375 -0.34375,0.359375 -0.230469,0 -0.34375,-0.121094 -0.34375,-0.359375 V 3.125 L 4.171875,2.5625 v 1.703125 c 0,0.226563 -0.117187,0.34375 -0.34375,0.34375 -0.230469,0 -0.34375,-0.117187 -0.34375,-0.34375 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 6.609375,2.484375 c 0.226563,0.0625 0.34375,0.21875 0.34375,0.46875 v 2.15625 c 0,0.363281 -0.15625,0.679687 -0.46875,0.953125 -0.304687,0.28125 -0.636719,0.421875 -1,0.421875 C 5.398438,6.484375 5.3125,6.46875 5.21875,6.4375 L 1.734375,5.515625 C 0.578125,5.203125 0,4.441406 0,3.234375 V 1.078125 C 0,0.972656 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.78125 0.34375,0.8125 Z M 6.265625,3.125 0.703125,1.625 V 3.421875 C 0.703125,3.722656 0.800781,4.003906 1,4.265625 1.195312,4.535156 1.441406,4.707031 1.734375,4.78125 L 5.21875,5.71875 C 5.3125,5.738281 5.394531,5.75 5.46875,5.75 c 0.238281,0 0.429688,-0.078125 0.578125,-0.234375 0.144531,-0.15625 0.21875,-0.355469 0.21875,-0.59375 z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,5.140625 V 3.921875 H 7.734375 C 7.453125,3.628906 7.171875,3.242188 6.890625,2.765625 6.609375,2.296875 6.398438,1.875 6.265625,1.5 H 7.4375 c 0.320312,0.675781 0.707031,1.269531 1.15625,1.78125 0.457031,0.507812 0.898438,0.867188 1.328125,1.078125 v 0.78125 z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.875,0.578125 c 1.164062,0 2.101562,0.117187 2.8125,0.359375 C 8.394531,1.175781 8.941406,1.53125 9.328125,2 9.722656,2.476562 9.921875,3.078125 9.921875,3.796875 9.921875,4.328125 9.8125,4.789062 9.59375,5.1875 9.382812,5.582031 9.078125,5.910156 8.671875,6.171875 8.273438,6.429688 7.785156,6.632812 7.203125,6.78125 6.628906,6.9375 5.851562,7.015625 4.875,7.015625 3.707031,7.015625 2.769531,6.894531 2.0625,6.65625 1.351562,6.414062 0.800781,6.054688 0.40625,5.578125 c -0.3867188,-0.46875 -0.578125,-1.0625 -0.578125,-1.78125 0,-0.960937 0.34375,-1.710937 1.03125,-2.25 C 1.679688,0.898438 3.019531,0.578125 4.875,0.578125 Z m 0,1.234375 C 3.25,1.8125 2.164062,2 1.625,2.375 1.09375,2.757812 0.828125,3.234375 0.828125,3.796875 c 0,0.550781 0.269531,1.015625 0.8125,1.390625 C 2.179688,5.570312 3.257812,5.765625 4.875,5.765625 6.5,5.765625 7.578125,5.570312 8.109375,5.1875 8.640625,4.8125 8.90625,4.34375 8.90625,3.78125 8.90625,3.21875 8.671875,2.773438 8.203125,2.453125 7.597656,2.023438 6.488281,1.8125 4.875,1.8125 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1.015625 H 9.875 V 2.3125 H 1.171875 v 4.875 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1363",
    transform: "translate(-338.8125,-121.97266)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,-6.04667e-4 H -56.161052 m -8.479166,0 h -8.317709 m -8.322916,0 h -8.479167 m -8.317708,0 h -41.921872 m -8.32292,0 h -8.31771 m -8.47916,0 h -8.32292 m -8.31771,0 h -41.92187 m -8.47917,0 h -8.31771 m -8.32292,0 h -8.47916",
    transform: "matrix(0.75,0,0,0.75,580.32001,725.51999)",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 508.16146,967.35938 H 452 v -46.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,6.15333e-4 V -8.322301 m 0,-8.479167 v -8.317708 m 0,-8.322917 V -75.35876 m 0,-8.322916 v -8.479167 m 0,-8.317707 v -8.32292 m 0,-8.47917 v -41.76041 m 0,-8.47917 v -8.31771 m 0,-8.32291 v -8.47917 m 0,-8.31771 v -41.92187 m 0,-8.32292 v -8.47917 m 0,-8.31771 v -8.32291 m 0,-8.47917 v -41.76042 m 0,-8.47916 v -8.31771 m 0,-8.32292 v -8.47916 m 0,-8.31771 v -41.92188 m 0,-8.31771 v -8.32291 m 0,-8.47917 v -8.31771 m 0,-8.32291 v -41.91667 m 0,-8.32292 v -8.47916 m 0,-8.32292 v -8.31771 m 0,-8.47916 v -41.76042 m 0,-8.47917 v -8.32291 m 0,-8.47917 v -8.31771 m 0,-8.32292 v -41.91666 m 0,-8.32292 v -8.47917 m 0,-8.3177 v -8.32292",
    transform: "matrix(0.75,0,0,0.75,339,684.48001)",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 452,209.1198 v -46.23959 h 56.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,2.08667e-4 H 8.478353 m 8.322917,0 h 8.317708 m 8.479167,0 H 75.52002 m 8.317708,0 h 8.322917 m 8.479165,0 h 8.31771 m 8.32292,0 h 41.92187 m 8.31771,0 h 8.47917 m 8.32291,0 h 8.31771",
    transform: "matrix(0.75,0,0,0.75,387.35998,122.16)",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 717.59896,162.88021 h 56.16146 v 46.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,-0.00104233 V 8.321874 m 0,8.317709 v 8.479166 m 0,8.322917 v 41.916667 m 0,8.322916 v 8.317709 m 0,8.479162 v 8.32292 m 0,8.47917 v 41.76041 m 0,8.47917 v 8.31771 m 0,8.32292 v 8.47916 m 0,8.32292 v 41.91667 m 0,8.32291 v 8.31771 m 0,8.47917 v 8.32291 m 0,8.31771 v 41.92188 m 0,8.31771 v 8.47916 m 0,8.32292 v 8.31771 m 0,8.47916 v 41.76042 m 0,8.47917 v 8.32291 m 0,8.31771 v 8.47917 m 0,8.32292 v 41.92187 m 0,8.31771 v 8.47917 m 0,8.32291 v 8.31771 m 0,8.47917 v 41.76041 m 0,8.47917 v 8.32292 m 0,8.31771 v 8.47916 m 0,8.32292 v 41.91667 m 0,8.32291 v 8.31771 m 0,8.47917 v 8.32291",
    transform: "matrix(0.75,0,0,0.75,580.32001,163.2)",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 773.76042,920.95834 v 46.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 580.32031,122.16016 -0.35937,17.76171 v -17.76171 z m 0,0",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 580.32031,122.16016 v 17.76171 h -0.35937 z m 0,0",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,139.67969 -2.64063,0.24218 v -0.24218 z m 0,0",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,139.67969 v 0.24218 h -2.64063 z m 0,0",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 577.32031,137.39844 -0.24219,2.52343 v -2.52343 z m 0,0",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 577.32031,137.39844 v 2.52343 h -0.24219 z m 0,0",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 568.07812,125.16016 -2.27734,0.23828 v -0.23828 z m 0,0",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 568.07812,125.16016 v 0.23828 h -2.27734 z m 0,0",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,122.16016 -14.16016,0.23828 v -0.23828 z m 0,0",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,122.16016 v 0.23828 h -14.16016 z m 0,0",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 565.80078,122.16016 -0.35937,3.23828 v -3.23828 z m 0,0",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 565.80078,122.16016 v 3.23828 h -0.35937 z m 0,0",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,2.08667e-4 H 19.840434 M 0.481059,0.317917 H 19.361267 M 19.840434,2.08667e-4 V 23.6825 M 19.361267,0.317917 v 23.041667 m 0.479167,0.322916 h -4.322917 m 3.84375,-0.322916 H 15.840434 M 15.517517,23.6825 v -3.364583 m 0.322917,3.041667 V 20.317917 M 0.001892,2.08667e-4 V 4.317917 m 0.479167,-4 V 4.000209 M 0.001892,4.317917 h 3.515625",
    transform: "matrix(0.75,0,0,0.75,565.43999,122.16)",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 754.40104,166.88021 h 3.03646 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,-0.002075 H -0.32251 m -4.958333,-16 v 1.442708 m 0,0.479167 v 1.598958 m 0,0.322917 v 1.598958 m 0,0.317709 v 1.604166 m 0,0.479167 v 1.598958 m 0,0.317709 v 1.604166",
    transform: "matrix(0.75,0,0,0.75,577.32001,137.39999)",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 764.47917,178.88021 v 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,-6.20667e-4 H 1.438985 m 0.479167,0 h 1.604167 m 0.317708,0 h 1.598958 m 0.479167,0 H 7.36086 m 0.479167,0 h 1.598958 m 0.322917,0 h 1.598958",
    transform: "matrix(0.75,0,0,0.75,567.11998,137.52)",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 768,183.35938 h 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339,122.16016 0.23828,17.76171 v -17.76171 z m 0,0",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339,122.16016 v 17.76171 h 0.23828 z m 0,0",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 339.23828,139.67969 342,139.92187 v -0.24218 z m 0,0",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339.23828,139.67969 v 0.24218 H 342 Z m 0,0",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 342,137.39844 0.23828,2.52343 v -2.52343 z m 0,0",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 342,137.39844 v 2.52343 h 0.23828 z m 0,0",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 351.23828,125.16016 2.28125,0.23828 v -0.23828 z m 0,0",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 351.23828,125.16016 v 0.23828 h 2.28125 z m 0,0",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339.23828,122.16016 14.28125,0.23828 v -0.23828 z m 0,0",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339.23828,122.16016 v 0.23828 h 14.28125 z m 0,0",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.51953,122.16016 0.24219,3.23828 v -3.23828 z m 0,0",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.51953,122.16016 v 3.23828 h 0.24219 z m 0,0",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,2.08667e-4 H -19.679993 M -0.320618,0.317917 H -19.362285 M -19.679993,2.08667e-4 V 23.6825 m 0.317708,-23.364583 v 23.041667 m -0.317708,0.322916 h 4.317708 m -4,-0.322916 h 3.682292 m 0.317708,0.322916 v -3.364583 m -0.317708,3.041667 V 20.317917 M 0.00229867,2.08667e-4 V 4.317917 m -0.32291667,-4 V 4.000209 M 0.00229867,4.317917 H -3.362285",
    transform: "matrix(0.75,0,0,0.75,353.75999,122.16)",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.35937,166.88021 h -3.04166 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,-0.002075 h 0.317708 m 4.802084,-16 v 1.442708 m 0,0.479167 v 1.598958 m 0,0.322917 v 1.598958 m 0,0.317709 v 1.604166 m 0,0.479167 v 1.598958 m 0,0.317709 v 1.604166",
    transform: "matrix(0.75,0,0,0.75,342,137.39999)",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,178.88021 v 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,-6.20667e-4 h -1.4375 m -0.317708,0 h -1.604167 m -0.317708,0 h -1.598959 m -0.479166,0 h -1.604167 m -0.317708,0 h -1.598959 m -0.479166,0 h -1.442709",
    transform: "matrix(0.75,0,0,0.75,352.08,137.52)",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 457.76042,183.35938 h -1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 580.32031,725.51953 -0.35937,-17.75781 v 17.75781 z m 0,0",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 580.32031,725.51953 v -17.75781 h -0.35937 z m 0,0",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,708 -2.64063,-0.23828 V 708 Z m 0,0",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,708 v -0.23828 h -2.64063 z m 0,0",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 577.32031,710.28125 -0.24219,-2.51953 v 2.51953 z m 0,0",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 577.32031,710.28125 v -2.51953 h -0.24219 z m 0,0",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 568.07812,722.51953 -2.27734,-0.23828 v 0.23828 z m 0,0",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 568.07812,722.51953 v -0.23828 h -2.27734 z m 0,0",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,725.51953 -14.16016,-0.35937 v 0.35937 z m 0,0",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 579.96094,725.51953 v -0.35937 h -14.16016 z m 0,0",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 565.80078,725.51953 -0.35937,-3.23828 v 3.23828 z m 0,0",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 565.80078,725.51953 v -3.23828 h -0.35937 z m 0,0",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,-6.04667e-4 H 19.840434 M 0.481059,-0.479771 h 18.880208 m 0.479167,0.479166333 V -23.677688 M 19.361267,-0.479771 V -23.35998 m 0.479167,-0.317708 h -4.322917 m 3.84375,0.317708 h -3.520833 m -0.322917,-0.317708 v 3.359375 m 0.322917,-3.041667 v 3.041667 M 0.001892,-6.04667e-4 V -4.318313 m 0.479167,3.838542 V -4.000605 M 0.001892,-4.318313 h 3.515625",
    transform: "matrix(0.75,0,0,0.75,565.43999,725.51999)",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 754.40104,963.35938 h 3.03646 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.001694 H -0.32251 m -4.958333,16 v -1.442708 m 0,-0.479167 v -1.598958 m 0,-0.322917 v -1.598958 m 0,-0.479167 v -1.4375 m 0,-0.484375 V 6.558986 m 0,-0.317709 V 4.642319",
    transform: "matrix(0.75,0,0,0.75,577.32001,710.27998)",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 764.47917,951.19792 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,2.08667e-4 H 1.438985 m 0.479167,0 h 1.604167 m 0.317708,0 h 1.598958 m 0.479167,0 H 7.36086 m 0.479167,0 h 1.598958 m 0.322917,0 h 1.598958",
    transform: "matrix(0.75,0,0,0.75,567.11998,710.16)",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 768,946.88021 h 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339,725.51953 0.23828,-17.75781 v 17.75781 z m 0,0",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339,725.51953 v -17.75781 h 0.23828 z m 0,0",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 339.23828,708 342,707.76172 V 708 Z m 0,0",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339.23828,708 v -0.23828 H 342 Z m 0,0",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 342,710.28125 0.23828,-2.51953 v 2.51953 z m 0,0",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 342,710.28125 v -2.51953 h 0.23828 z m 0,0",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 351.23828,722.51953 2.28125,-0.23828 v 0.23828 z m 0,0",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 351.23828,722.51953 v -0.23828 h 2.28125 z m 0,0",
    id: "path79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339.23828,725.51953 14.28125,-0.35937 v 0.35937 z m 0,0",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 339.23828,725.51953 v -0.35937 h 14.28125 z m 0,0",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.51953,725.51953 0.24219,-3.23828 v 3.23828 z m 0,0",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.51953,725.51953 v -3.23828 h 0.24219 z m 0,0",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,-6.04667e-4 H -19.679993 M -0.320618,-0.479771 h -19.041667 m -0.317708,0.479166333 V -23.677688 m 0.317708,23.197917 V -23.35998 m -0.317708,-0.317708 h 4.317708 m -4,0.317708 h 3.682292 m 0.317708,-0.317708 v 3.359375 m -0.317708,-3.041667 v 3.041667 M 0.00229867,-6.04667e-4 V -4.318313 M -0.320618,-0.479771 V -4.000605 M 0.00229867,-4.318313 H -3.362285",
    transform: "matrix(0.75,0,0,0.75,353.75999,725.51999)",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.35937,963.35938 h -3.04166 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,0.001694 h 0.317708 m 4.802084,16 v -1.442708 m 0,-0.479167 v -1.598958 m 0,-0.322917 v -1.598958 m 0,-0.479167 v -1.4375 m 0,-0.484375 V 6.558986 m 0,-0.317709 V 4.642319",
    transform: "matrix(0.75,0,0,0.75,342,710.27998)",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 461.11979,951.19792 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,2.08667e-4 h -1.4375 m -0.317708,0 h -1.604167 m -0.317708,0 h -1.598959 m -0.479166,0 h -1.604167 m -0.317708,0 h -1.598959 m -0.479166,0 h -1.442709",
    transform: "matrix(0.75,0,0,0.75,352.08,710.16)",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 457.76042,946.88021 h -1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 617.76042,321.1198 v 158.23958 h -9.92188 V 321.1198 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00125633 -0.801677,-0.962285 -1.598552,-1.75916 l -1.119791,-0.479167 -1.119792,-0.322917 -1.119792,-0.15625 -1.119791,0.15625 -1.119792,0.322917 -1.125,0.479167 -0.796875,0.796875 -0.802083,0.96354133",
    transform: "matrix(0.75,0,0,0.75,463.32001,240.95999)",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00148533,-6.04667e-4 0.800598,0.957729 1.597473,1.759812 2.722473,2.238979 3.842265,2.561895 4.962056,2.718145 6.081848,2.561895 7.20164,2.238979 8.321431,1.759812 9.118306,0.957729 9.92039,-6.04667e-4",
    transform: "matrix(0.75,0,0,0.75,455.88002,359.51999)",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 612.80208,321.1198 V 479.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path93"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g93"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 465.47534,
    y: 277.79956,
    id: "use93"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8576.5124,-14250.727 c 8.779,3.796 13.2872,13.169 13.2872,27.998 0,3.796 -0.7119,7.83 -1.8982,11.864 l -5.6945,21.354 c -6.0504,23.49 -18.3885,39.15 -37.0143,46.98 -9.2535,3.796 -19.8121,5.694 -31.7943,5.694 h -40.8106 c -6.9994,0 -10.4399,-3.44 -10.4399,-10.44 0,-7.237 3.4405,-10.914 10.4399,-10.914 h 46.5051 c 9.135,0 17.6767,-2.966 25.6253,-9.017 8.1858,-5.931 13.4058,-13.405 15.6599,-22.303 l 5.6945,-21.354 c 1.1863,-4.39 1.8981,-8.305 1.8981,-11.864 0,-13.287 -8.779,-19.931 -26.0998,-19.931 h -18.9816 c -7.3554,0 -10.9145,-3.44 -10.9145,-10.44 0,-6.881 3.5591,-10.44 10.9145,-10.44 h 24.6761 c 12.5754,0 23.4899,-5.22 32.7434,-15.66 4.3895,-4.982 7.2368,-10.439 8.5418,-16.134 0.9491,-3.44 1.4236,-6.644 1.4236,-9.491 0,-14.829 -8.5417,-22.303 -25.6253,-22.303 h -41.2851 c -6.9995,0 -10.4399,-3.441 -10.4399,-10.44 0,-6.881 3.4404,-10.44 10.4399,-10.44 h 46.9796 c 16.3717,0 28.4726,7.474 36.0652,22.303 3.4405,6.407 5.22,13.169 5.22,20.406 0,3.559 -0.3559,6.881 -0.9491,9.965 -6.0504,23.134 -17.4394,37.963 -34.167,44.607 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path94"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g94"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 465.47534,
    y: 282.75671,
    id: "use94"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8669.6412,-14158.191 c 21.8289,0 35.5907,-10.44 41.2852,-31.32 l 5.6945,-21.354 c 1.1863,-4.034 1.8981,-8.068 1.8981,-11.864 0,-13.287 -8.8976,-19.931 -26.5743,-19.931 h -32.7434 l -13.7617,53.149 c -0.9491,3.203 -1.4236,5.694 -1.4236,7.593 0,7.355 2.3727,13.168 7.1181,17.558 4.9827,4.152 11.1517,6.169 18.5071,6.169 z m -5.6945,21.354 c -14.9481,0 -26.8116,-7.711 -35.5906,-23.253 -4.1523,-6.643 -6.1691,-13.524 -6.1691,-20.879 0,-2.848 0.4746,-5.695 1.4237,-8.542 l 17.0835,-63.589 c 5.9317,-23.371 16.3717,-42.946 31.3197,-58.843 16.7276,-17.677 38.4379,-29.54 65.0122,-35.591 0.5932,-0.237 1.4237,-0.474 2.3728,-0.474 7.2367,0 10.9144,3.559 10.9144,10.44 0,6.05 -2.3727,9.372 -7.1181,9.965 -11.7449,1.661 -23.6085,6.051 -35.5906,13.287 -21.5917,13.05 -35.3534,29.897 -41.2852,50.776 h 31.7943 c 11.9822,0 21.9476,4.034 29.8962,11.864 7.8299,7.593 11.8635,17.439 11.8635,29.422 0,4.152 -0.4745,7.948 -1.4236,11.389 l -5.6945,21.354 c -6.6436,24.676 -18.5072,40.573 -35.5907,47.454 -8.8976,3.559 -19.9307,5.22 -33.2179,5.22 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path95"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g95"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 465.47534,
    y: 287.61667,
    id: "use95"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8884.6086,-14240.762 -61.2158,99.18 c -1.8982,3.203 -4.9827,4.745 -9.0163,4.745 -2.8473,0 -5.4573,-1.068 -7.5927,-3.322 -1.8982,-2.135 -2.8473,-4.745 -2.8473,-7.592 l 7.1182,-189.817 c 0,-6.881 3.4404,-10.44 10.4399,-10.44 7.5927,0 11.1517,3.678 10.9144,10.914 l -6.169,150.43 56.945,-93.01 c 1.8982,-3.44 4.7454,-5.22 8.5418,-5.22 6.8808,0 10.5585,3.322 10.9144,9.965 l 7.1182,89.689 77.3503,-157.074 c 1.8981,-3.796 4.9827,-5.694 9.4908,-5.694 6.8809,0 10.4399,3.559 10.4399,10.44 0,1.661 -0.3559,3.203 -0.9491,4.745 l -94.4338,190.292 c -1.8981,3.796 -4.9827,5.694 -9.0163,5.694 -6.9995,0 -10.6772,-3.322 -10.9144,-9.965 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path96"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g96"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 465.59717,
    y: 302.03873,
    id: "use96"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9296.0364,-14161.869 c 7.2367,0 10.9144,3.678 10.9144,10.914 0,7 -3.6777,10.44 -10.9144,10.44 h -90.163 c -3.2031,0 -5.5758,-0.949 -7.1181,-2.847 -1.6609,-2.135 -1.8982,-4.745 -0.9491,-7.593 l 51.7251,-192.664 c 1.5422,-5.338 4.864,-8.067 9.9654,-8.067 7.2367,0 10.9144,3.559 10.9144,10.44 0,1.305 -0.2373,2.254 -0.4745,2.847 l -47.4542,176.53 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path97"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g97"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 465.59717,
    y: 306.99588,
    id: "use97"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9453.2283,-14246.337 h -57.4195 l -22.778,84.468 h 73.5539 c 7.2368,0 10.9145,3.678 10.9145,10.914 0,7 -3.6777,10.44 -10.9145,10.44 h -90.1629 c -3.2031,0 -5.5759,-0.949 -7.1181,-2.847 -1.6609,-2.135 -1.8982,-4.745 -0.9491,-7.593 l 50.776,-190.291 c 1.8981,-6.881 6.6436,-10.44 14.2362,-10.44 h 83.9939 c 7.2368,0 10.9145,3.559 10.9145,10.44 0,7 -3.6777,10.44 -10.9145,10.44 h -78.7739 l -17.0835,63.589 h 51.725 c 6.8809,0 10.44,3.559 10.44,10.44 0,6.999 -3.5591,10.44 -10.44,10.44 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path98"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g98"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 465.59717,
    y: 311.85583,
    id: "use98"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9546.7131,-14341.246 c 1.8981,-6.881 6.6436,-10.44 14.2362,-10.44 h 65.4868 c 11.0331,0 20.6426,4.746 28.947,14.236 8.5418,9.254 12.8127,19.338 12.8127,30.371 0,2.61 -0.4746,5.22 -1.4237,8.067 l -27.9979,105.823 c -9.4909,35.116 -32.6248,52.674 -69.2831,52.674 h -65.4868 c -3.2032,0 -5.5759,-0.949 -7.1181,-2.847 -1.6609,-2.135 -1.8982,-4.745 -0.9491,-7.593 z m 19.4562,10.44 -45.556,168.937 h 54.5723 c 9.1349,0 17.6767,-2.966 25.6252,-9.016 8.1859,-5.932 13.4058,-13.406 15.6599,-22.304 l 28.4725,-105.823 c 0.5932,-2.847 0.9491,-5.338 0.9491,-7.592 0,-7.237 -2.3727,-13.05 -7.1181,-17.558 -4.7454,-4.39 -10.7959,-6.644 -18.0326,-6.644 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 630.40104,402.71875 v 23.6823 h -10.08333 v -23.6823 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 617.76042,724.80209 v 158.23958 h -9.92188 V 724.80209 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00210067 -0.801677,-0.961441 l -0.796875,-0.796875 -1.119791,-0.479167 -1.119792,-0.322916 -1.119792,-0.161459 -1.119791,0.161459 -1.119792,0.322916 -1.125,0.479167 -0.796875,0.796875 -0.802083,0.96354167",
    transform: "matrix(0.75,0,0,0.75,463.32001,543.59999)",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00148533,2.08667e-4 0.800598,0.958542 1.597473,1.760625 2.722473,2.239792 3.842265,2.5575 4.962056,2.718959 6.081848,2.5575 7.20164,2.239792 8.321431,1.760625 9.118306,0.958542 9.92039,2.08667e-4",
    transform: "matrix(0.75,0,0,0.75,455.88002,662.16)",
    id: "path103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 612.80208,724.80209 V 883.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path104"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g104"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 465.47534,
    y: 580.43488,
    id: "use104"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 17767.675,-14250.727 c 8.779,3.796 13.287,13.169 13.287,27.998 0,3.796 -0.712,7.83 -1.898,11.864 l -5.695,21.354 c -6.05,23.49 -18.388,39.15 -37.014,46.98 -9.253,3.796 -19.812,5.694 -31.794,5.694 h -40.811 c -6.999,0 -10.44,-3.44 -10.44,-10.44 0,-7.237 3.441,-10.914 10.44,-10.914 h 46.505 c 9.135,0 17.677,-2.966 25.626,-9.017 8.185,-5.931 13.405,-13.405 15.659,-22.303 l 5.695,-21.354 c 1.186,-4.39 1.898,-8.305 1.898,-11.864 0,-13.287 -8.779,-19.931 -26.1,-19.931 h -18.981 c -7.356,0 -10.915,-3.44 -10.915,-10.44 0,-6.881 3.559,-10.44 10.915,-10.44 h 24.676 c 12.575,0 23.49,-5.22 32.743,-15.66 4.39,-4.982 7.237,-10.439 8.542,-16.134 0.949,-3.44 1.424,-6.644 1.424,-9.491 0,-14.829 -8.542,-22.303 -25.626,-22.303 h -41.285 c -6.999,0 -10.44,-3.441 -10.44,-10.44 0,-6.881 3.441,-10.44 10.44,-10.44 h 46.98 c 16.372,0 28.472,7.474 36.065,22.303 3.44,6.407 5.22,13.169 5.22,20.406 0,3.559 -0.356,6.881 -0.949,9.965 -6.05,23.134 -17.439,37.963 -34.167,44.607 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path105"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g105"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 465.47534,
    y: 585.39203,
    id: "use105"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 17860.804,-14158.191 c 21.829,0 35.59,-10.44 41.285,-31.32 l 5.694,-21.354 c 1.187,-4.034 1.899,-8.068 1.899,-11.864 0,-13.287 -8.898,-19.931 -26.575,-19.931 h -32.743 l -13.762,53.149 c -0.949,3.203 -1.424,5.694 -1.424,7.593 0,7.355 2.373,13.168 7.119,17.558 4.982,4.152 11.151,6.169 18.507,6.169 z m -5.695,21.354 c -14.948,0 -26.811,-7.711 -35.59,-23.253 -4.153,-6.643 -6.169,-13.524 -6.169,-20.879 0,-2.848 0.474,-5.695 1.423,-8.542 l 17.084,-63.589 c 5.931,-23.371 16.371,-42.946 31.319,-58.843 16.728,-17.677 38.438,-29.54 65.013,-35.591 0.593,-0.237 1.423,-0.474 2.372,-0.474 7.237,0 10.915,3.559 10.915,10.44 0,6.05 -2.373,9.372 -7.118,9.965 -11.745,1.661 -23.609,6.051 -35.591,13.287 -21.592,13.05 -35.353,29.897 -41.285,50.776 h 31.794 c 11.982,0 21.948,4.034 29.896,11.864 7.83,7.593 11.864,17.439 11.864,29.422 0,4.152 -0.475,7.948 -1.424,11.389 l -5.694,21.354 c -6.644,24.676 -18.507,40.573 -35.591,47.454 -8.898,3.559 -19.931,5.22 -33.218,5.22 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path106"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g106"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 465.47534,
    y: 590.25201,
    id: "use106"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18075.89,-14240.762 -61.216,99.18 c -1.898,3.203 -4.983,4.745 -9.016,4.745 -2.848,0 -5.458,-1.068 -7.593,-3.322 -1.898,-2.135 -2.847,-4.745 -2.847,-7.592 l 7.118,-189.817 c 0,-6.881 3.44,-10.44 10.44,-10.44 7.592,0 11.151,3.678 10.914,10.914 l -6.169,150.43 56.945,-93.01 c 1.898,-3.44 4.746,-5.22 8.542,-5.22 6.881,0 10.558,3.322 10.914,9.965 l 7.119,89.689 77.35,-157.074 c 1.898,-3.796 4.983,-5.694 9.491,-5.694 6.881,0 10.44,3.559 10.44,10.44 0,1.661 -0.356,3.203 -0.95,4.745 l -94.433,190.292 c -1.898,3.796 -4.983,5.694 -9.017,5.694 -6.999,0 -10.677,-3.322 -10.914,-9.965 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path107"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g107"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 465.59717,
    y: 604.67212,
    id: "use107"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18487.199,-14161.869 c 7.237,0 10.914,3.678 10.914,10.914 0,7 -3.677,10.44 -10.914,10.44 h -90.163 c -3.203,0 -5.576,-0.949 -7.118,-2.847 -1.661,-2.135 -1.898,-4.745 -0.949,-7.593 l 51.725,-192.664 c 1.542,-5.338 4.864,-8.067 9.965,-8.067 7.237,0 10.915,3.559 10.915,10.44 0,1.305 -0.238,2.254 -0.475,2.847 l -47.454,176.53 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path108"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g108"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 465.59717,
    y: 609.62927,
    id: "use108"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18644.391,-14246.337 h -57.42 l -22.778,84.468 h 73.554 c 7.237,0 10.915,3.678 10.915,10.914 0,7 -3.678,10.44 -10.915,10.44 h -90.163 c -3.203,0 -5.576,-0.949 -7.118,-2.847 -1.661,-2.135 -1.898,-4.745 -0.949,-7.593 l 50.776,-190.291 c 1.898,-6.881 6.644,-10.44 14.236,-10.44 h 83.994 c 7.237,0 10.915,3.559 10.915,10.44 0,7 -3.678,10.44 -10.915,10.44 h -78.774 l -17.083,63.589 h 51.725 c 6.881,0 10.44,3.559 10.44,10.44 0,6.999 -3.559,10.44 -10.44,10.44 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path109"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g109"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 465.59717,
    y: 614.48926,
    id: "use109"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18737.876,-14341.246 c 1.898,-6.881 6.643,-10.44 14.236,-10.44 h 65.487 c 11.033,0 20.642,4.746 28.947,14.236 8.541,9.254 12.812,19.338 12.812,30.371 0,2.61 -0.474,5.22 -1.423,8.067 l -27.998,105.823 c -9.491,35.116 -32.625,52.674 -69.283,52.674 h -65.487 c -3.203,0 -5.576,-0.949 -7.118,-2.847 -1.661,-2.135 -1.898,-4.745 -0.949,-7.593 z m 19.456,10.44 -45.556,168.937 h 54.572 c 9.135,0 17.677,-2.966 25.625,-9.016 8.186,-5.932 13.406,-13.406 15.66,-22.304 l 28.473,-105.823 c 0.593,-2.847 0.949,-5.338 0.949,-7.592 0,-7.237 -2.373,-13.05 -7.118,-17.558 -4.746,-4.39 -10.796,-6.644 -18.033,-6.644 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 630.40104,806.40105 v 23.67708 h -10.08333 v -23.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 748.80208,700 v 88.95834 H 669.92187 V 700 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 700.16146,788.95834 V 700",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,0.00250733 0.318929,-0.158951 0.480388,0.00250733 0.798096,-0.158951 0.959554,0.00250733 1.282471,-0.158951 1.438721,0.00250733 1.761638,-0.158951 1.917888,0.00250733 2.240804,-0.158951 2.402263,0.00250733 2.719971,-0.158951 2.881429,0.00250733 3.199138,-0.158951 3.360596,0.00250733 3.678304,-0.158951",
    transform: "matrix(0.75,0,0,0.75,561.96002,547.91999)",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-0.00121567 0.318929,0.160243 0.480388,-0.00121567 0.798096,0.160243 0.959554,-0.00121567 1.282471,0.160243 1.438721,-0.00121567 1.761638,0.160243 1.917888,-0.00121567 2.240804,0.160243 2.402263,-0.00121567 2.719971,0.160243 2.881429,-0.00121567 3.199138,0.160243 3.360596,-0.00121567 3.678304,0.160243",
    transform: "matrix(0.75,0,0,0.75,561.96002,545.03997)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001892,2.08667e-4 V 3.521042 M -0.481059,2.08667e-4 V 3.521042 M 0.482483,2.08667e-4 V 3.521042 M 0.96165,2.08667e-4 V 3.521042 M -0.3196,3.6825 V -0.16125 M 0.159566,3.6825 V -0.16125 M 0.638733,3.6825 V -0.16125 M 1.1179,3.6825 V -0.16125 M 1.440816,2.08667e-4 V 3.521042 M 1.919983,2.08667e-4 V 3.521042 M 2.39915,2.08667e-4 V 3.521042 m 0.479166,0 V 2.08667e-4 M 1.602275,3.6825 V -0.16125 M 2.081441,3.6825 V -0.16125 M 2.560608,3.6825 V -0.16125 M -0.798767,3.6825 v -3.84375",
    transform: "matrix(0.75,0,0,0.75,562.56001,545.16)",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-0.00101233 0.318929,-0.162471 0.480388,-0.00101233 0.798096,-0.162471 0.959554,-0.00101233 1.282471,-0.162471 1.438721,-0.00101233 1.761638,-0.162471 1.917888,-0.00101233 2.240804,-0.162471 2.402263,-0.00101233 2.719971,-0.162471 2.881429,-0.00101233 3.199138,-0.162471 3.360596,-0.00101233 3.678304,-0.162471",
    transform: "matrix(0.75,0,0,0.75,561.96002,538.19998)",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,4.12e-4 0.318929,0.16187 0.480388,4.12e-4 0.798096,0.16187 0.959554,4.12e-4 1.282471,0.16187 1.438721,4.12e-4 1.761638,0.16187 1.917888,4.12e-4 2.240804,0.16187 2.402263,4.12e-4 2.719971,0.16187 2.881429,4.12e-4 3.199138,0.16187 3.360596,4.12e-4 3.678304,0.16187",
    transform: "matrix(0.75,0,0,0.75,561.96002,535.32)",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001892,0.00189733 V 3.517522 M -0.481059,0.00189733 V 3.517522 M 0.482483,0.00189733 V 3.517522 M 0.96165,0.00189733 V 3.517522 M -0.3196,3.678981 V -0.159561 M 0.159566,3.678981 V -0.159561 M 0.638733,3.678981 V -0.159561 M 1.1179,3.678981 V -0.159561 M 1.440816,0.00189733 V 3.517522 M 1.919983,0.00189733 V 3.517522 M 2.39915,0.00189733 V 3.517522 m 0.479166,0 V 0.00189733 M 1.602275,3.678981 v -3.838542 m 0.479166,3.838542 v -3.838542 m 0.479167,3.838542 v -3.838542 m -3.359375,3.838542 v -3.838542 m -78.71875,26.880208 v -37.28125",
    transform: "matrix(0.75,0,0,0.75,562.56001,535.43998)",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,702.71875 h -0.3177 l -0.32292,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,702.5625 h 4.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.47917,703.35938 v -0.31771 l -0.16146,-0.16146 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.64062,703.35938 v 82.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.83854,786.23959 h 0.32292 l 0.15625,-0.16146 0.16146,-0.15625 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.83854,786.40105 h -4.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,785.59896 v 0.32292 l 0.16146,0.15625 0.16146,0.16146 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.5625,785.59896 v -37.28125 m -0.32292,-6.07812 v -39.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,702.23959 h -0.32292 l -0.15625,0.16146 -0.16146,0.16145 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,702.07813 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.80208,702.88021 v -0.31771 l -0.32291,-0.32291 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.95833,702.88021 v 83.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,786.71875 h 0.31771 l 0.16145,-0.15625 0.16146,-0.16145 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,786.88021 h -5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.40104,786.07813 v 0.32292 l 0.31771,0.3177 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00188667 V -39.361262 M 6.879802,2.878322 V -86.080012 M 10.077718,2.878322 V -86.080012 M -0.318115,-57.762303 H 6.879802 M 2.400635,-78.24147 v 15.041667",
    transform: "matrix(0.75,0,0,0.75,502.67999,589.56001)",
    id: "path135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,721.4375 0.15625,0.48438 0.16145,0.47917 0.47917,0.3177 0.47917,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 670.88021,721.4375 V 709.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 672.31771,707.83855 671.83854,708 l -0.47917,0.31771 -0.16145,0.48438 -0.15625,0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,708.47917 v -0.16146 L 672.64062,708 l -0.16145,-0.16145 h -0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,708.47917 v 13.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.31771,722.88021 h 0.16146 l 0.16145,-0.16146 0.16146,-0.3177 v -0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00188667 0.482076,-0.158137 1.117493,-0.642512 1.44041,-1.439387 1.919576,-2.39772 2.242493,-4.96022 V -6.24147 L 2.081035,-7.517512 1.919576,-8.798762 1.44041,-9.762303 l -0.322917,-0.796875 -0.635417,-0.479167 -0.48437467,-0.161458 -0.47916633,0.161458 -0.640625,0.479167 -0.317709,0.796875 -0.479166,0.963541 -0.161459,1.28125 -0.161458,1.276042 v 1.28125 l 0.322917,2.5625 0.479166,0.958333 0.317709,0.796875 0.640625,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,504.24,562.56001)",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,0.00122633 0.480652,-0.160232 0.959819,-0.639399 1.277527,-1.441482 1.600444,-2.399815 1.918152,-3.519607 v -2.5625 L 1.600444,-7.201899 1.277527,-8.160232 0.959819,-8.962315 0.480652,-9.441482 l -0.47916667,-0.15625 -0.47916633,0.15625 -0.484375,0.479167 -0.317709,0.802083 -0.317708,0.958333 -0.322917,1.119792 v 2.5625 l 0.322917,1.119792 0.317708,0.958333 0.317709,0.802083 0.484375,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,504.11998,561.96002)",
    id: "path143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,0.00189733 0.481262,0.158147 0.960429,-0.159561 1.439595,-0.800186 1.918762,-1.602269 2.08022,-2.722061 2.397929,-3.998103 V -6.878311 L 2.08022,-8.159561 1.918762,-9.279353 1.439595,-10.081436 0.960429,-10.722061 0.481262,-11.039769 0.00209533,-10.878311",
    transform: "matrix(0.75,0,0,0.75,504.59999,562.43998)",
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-4.01333e-4 0.480388,0.640224 0.798096,0.957932 1.282471,1.11939 2.079346,0.322515 2.402263,-0.479568 2.719971,-1.59936 l 0.161458,-1.28125 0.15625,-1.4375 v -2.880208 l -0.15625,-1.442708 -0.161458,-1.28125 -0.317708,-1.119792 -0.322917,-0.796875 -0.479167,-0.479167 -0.317708,-0.322916 -0.484375,0.161458 -0.317708,0.317708 -0.479167,0.640625",
    transform: "matrix(0.75,0,0,0.75,504.96002,562.67999)",
    id: "path145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.11979,738.71875 h -0.80208 m 0.80208,11.52084 h -0.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,764.47917 v 9.28125 h -1.28125 v -9.28125 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,759.35938 v -0.31771 l -0.32292,-0.32292 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,758.71875 h -3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,758.71875 h -0.31771 l -0.32291,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.19792,759.35938 v 19.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.19792,778.88021 v 0.31771 l 0.32291,0.32292 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,779.52084 h 3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,779.52084 h 0.3177 l 0.32292,-0.32292 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 675.68229,778.88021 V 759.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,758.88021 v -0.31771 l -0.32292,-0.32291 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,758.07813 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.68229,758.23959 h -0.32292 l -0.16145,0.16146 -0.15625,0.16145 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.88021,758.88021 v 20.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,779.35938 v 0.32292 l 0.3177,0.3177 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.68229,780.16146 h 3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,780 h 0.31771 L 676,779.83855 l 0.16146,-0.15625 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 676.31771,779.35938 V 758.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00209 H -0.162068 V -0.319798 H -6.1e-4 v -0.317709 h -0.161458 l -0.317709,0.317709 0.161459,0.479166 0.15625,0.161459 H -6.1e-4 V -0.319798 -0.00209 H -0.162068 V 0.320827 H 0.160848 L 0.322307,-0.15834 V -0.481257 L -6.1e-4,-0.637507 h 0.161458 v 0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.51999,533.4)",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,0.002304 H -0.162068 V -0.159154 H -6.1e-4 v -0.479167 h -0.161458 l -0.317709,0.479167 0.161459,0.317708 0.15625,0.161458 H -6.1e-4 V -0.159154 0.002304 H -0.162068 V 0.320012 H 0.160848 L 0.322307,0.002304 V -0.482071 L -6.1e-4,-0.638321 h 0.161458 v 0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.51999,536.75999)",
    id: "path165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,718.5625 h 0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,718.88021 h -0.64062 v -0.47916 l 0.47916,-0.32292 h -0.47916 v -0.31771 h 0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,718.23959 -0.48437,0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,712.31771 -0.47916,-0.15625 v -0.32291 L 675.68229,712",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,712.64063 -0.64062,0.31771 v -0.47917 l 0.47916,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,714.40105 -0.47916,-0.32292 v -0.31771 l 0.47916,-0.16146 h -0.47916 v -0.47916 l 0.64062,0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,713.76042 -0.48437,0.16146 0.48437,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,714.71875 h -0.64062 v -0.3177 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00168333 H 0.48228 V 0.477483 H 0.159363 L -0.00209533,0.321233 -0.158345,0.159775 -0.319804,-0.00168333 -0.158345,-0.319392 -0.00209533,-0.48085 0.159363,-0.642308 H 0.48228 v 0.484375 h -0.48437533 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.40001,537.72001)",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00148 V 0.159978 H 0.159363 L 0.320821,-0.00148 H 0.159363 V 0.477687 H -0.00209533 L -0.158345,0.321437 -0.319804,-0.00148 -0.158345,-0.319188 -0.00209533,-0.480647 H 0.159363 -0.00209533 0.320821 L 0.48228,-0.15773 0.320821,0.321437 0.159363,0.477687 H 0.320821 V 0.159978 H 0.159363 V -0.00148 l 0.161458,-0.15625 h -0.32291633 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.40001,539.88002)",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,5.33333e-6 V 0.64063 m 0,0.640625 v 0.479167 m 0,0.317708 v 0.640625 m 0,3.041667 v 0.479167 m 0,0.322916 v 0.317709",
    transform: "matrix(0.75,0,0,0.75,506.75999,534)",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,563.28125 -0.35938,2.87891 v -2.87891 z m 0,0",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,563.28125 v 2.87891 h -0.35938 z m 0,0",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,550.55859 -0.35938,2.88282 v -2.88282 z m 0,0",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,550.55859 v 2.88282 h -0.35938 z m 0,0",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,564.23828 -0.35938,2.88281 v -2.88281 z m 0,0",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,564.23828 v 2.88281 h -0.35938 z m 0,0",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,549.60156 -0.35938,2.87891 v -2.87891 z m 0,0",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,549.60156 v 2.87891 h -0.35938 z m 0,0",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,564.60156 -0.36329,2.75781 v -2.75781 z m 0,0",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,564.60156 v 2.75781 h -0.36329 z m 0,0",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,549.35937 -0.36329,2.76172 v -2.76172 z m 0,0",
    id: "path187"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,549.35937 v 2.76172 h -0.36329 z m 0,0",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,564.35937 -0.24219,2.87891 v -2.87891 z m 0,0",
    id: "path189"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,564.35937 v 2.87891 h -0.24219 z m 0,0",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,549.48047 -0.24219,2.8789 v -2.8789 z m 0,0",
    id: "path191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,549.48047 v 2.8789 h -0.24219 z m 0,0",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,564 -0.23829,2.76172 V 564 Z m 0,0",
    id: "path193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,564 v 2.76172 h -0.23829 z m 0,0",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,549.96094 -0.23829,2.75781 v -2.75781 z m 0,0",
    id: "path195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,549.96094 v 2.75781 h -0.23829 z m 0,0",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,562.67969 -0.12109,2.8789 v -2.8789 z m 0,0",
    id: "path197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,562.67969 v 2.8789 h -0.12109 z m 0,0",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,551.16016 -0.12109,2.8789 v -2.8789 z m 0,0",
    id: "path199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,551.16016 v 2.8789 h -0.12109 z m 0,0",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,737.92188 v -3.84375 h -0.47917 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,736.64063 v -3.83854 h -0.47917 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.92187,736.16146 v -3.68229 h -0.48437 v 3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,736.47917 v -3.83854 h -0.32291 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,736.95834 v -3.67709 h -0.31771 v 3.67709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,738.71875 v -3.83854 h -0.16146 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,751.04167 v 3.83854 h -0.47917 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,752.31771 v 3.84375 h -0.47917 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.92187,752.80209 v 3.67708 h -0.48437 v -3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,752.47917 v 3.83854 h -0.32291 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,752 v 3.6823 h -0.31771 V 752 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,750.23959 v 3.83854 h -0.16146 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.35937,784.64063 h 0.32292 l 0.15625,-0.16146 L 676,784.31771 V 784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.35937,784.64063 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,784 v 0.31771 l 0.16146,0.16146 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,784 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,782.07813 h -0.32292 l -0.15625,0.16146 -0.16146,0.16146 v 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,782.07813 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,782.71875 v -0.3177 l -0.16146,-0.16146 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 676,782.71875 V 784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,784.31771 0.16145,-0.15625 L 675.52083,784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,784.31771 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.5625,784 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,784 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,782.40105 -0.31771,0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,782.23959 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,782.71875 -0.16146,-0.15625 -0.16145,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 675.68229,782.71875 V 784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,784.64063 h 0.32292 l 0.15625,-0.16146 0.16146,-0.16146 V 784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,784.64063 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,784 v 0.31771 l 0.32292,0.32292 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,784 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,782.07813 h -0.3177 l -0.32292,0.32292 v 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,782.07813 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.59896,782.71875 v -0.3177 l -0.16146,-0.16146 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 673.59896,782.71875 V 784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 672.80208,784.31771 673.11979,784",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,784.31771 h -1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,784 0.15625,0.16146 0.16145,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.88021,784 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,782.40105 -0.3177,0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,782.23959 h 1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.11979,782.71875 -0.16146,-0.15625 -0.15625,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 673.28125,782.71875 V 784 m -3.35938,-84 4.64063,0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.95833,703.52084 -0.15625,-0.64063 -0.16146,-0.64062 -0.32291,-0.47917 -0.63542,-0.47917 -0.48437,-0.16145 -0.63542,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 677.11979,703.52084 V 785.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.5625,788 0.63542,-0.16145 0.48437,-0.15625 0.63542,-0.48438 0.32291,-0.47917 0.16146,-0.64062 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,5.33333e-6 -4.638123,0.958339 M -4.799581,-79.35937 h 0.161458 m -0.161458,71.677084 h 0.161458 m 0,-80.317709 V 0.958339 M -4.799581,-79.35937 v 71.677084 m 81.4375,-2.239584 h -1.916667 m 0.640625,-2.71875 h -0.640625",
    transform: "matrix(0.75,0,0,0.75,505.92,591)",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,6.15333e-4 0.158142,0.479782 0.3196,0.958949 1.277934,1.281865 1.762309,1.120407 2.241475,0.958949 2.397725,0.479782 2.559184,6.15333e-4",
    transform: "matrix(0.75,0,0,0.75,562.43999,582.48001)",
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,2.08667e-4 -0.162272,-0.478958 l -0.15625,-0.479167 -0.479166,-0.161458 -0.484375,-0.161458 -0.958334,0.322916 -0.161458,0.479167 -0.15625,0.479166667",
    transform: "matrix(0.75,0,0,0.75,564.35999,533.16)",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,6.15333e-4 V -46.238968 m 0,-3.520833 v -9.442709 m 0,-3.515625 v -3.041666 M -2.558105,6.15333e-4 V -46.238968 m 0,-3.520833 v -9.442709 m 0,-3.515625 v -3.041666 m -1.119792,-10.880209 -4.484375,8 m -1.916666,3.520834 -7.520834,13.916666 m -1.921875,3.364584 -7.520833,13.916666 m -1.916667,3.520834 -7.682291,13.921875 m -1.760417,3.359375 -7.677083,13.916666",
    transform: "matrix(0.75,0,0,0.75,564.35999,582.48001)",
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 704.47917,780.95834 -4.31771,8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,-0.00168333 -4.48228,-8.001683 m -1.916666,-3.520834 -7.520834,-13.916666 m -1.921875,-3.359375 -7.520833,-13.921875 m -1.916667,-3.520834 -7.682291,-13.916666 m -1.760417,-3.364584 -7.677083,-13.916666",
    transform: "matrix(0.75,0,0,0.75,561.59999,591.72001)",
    id: "path253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 704.47917,708 -4.31771,-8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 748.80208,610.88021 V 700 h -78.88021 v -89.11979 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 700.16146,700 V 610.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-0.00249667 0.318929,-0.158747 0.480388,-0.00249667 0.798096,-0.158747 0.959554,-0.00249667 1.282471,-0.158747 1.438721,-0.00249667 1.761638,-0.158747 1.917888,-0.00249667 2.240804,-0.158747 2.402263,-0.00249667 2.719971,-0.158747 2.881429,-0.00249667 3.199138,-0.158747 3.360596,-0.00249667 3.678304,-0.158747",
    transform: "matrix(0.75,0,0,0.75,561.96002,481.08)",
    id: "path257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-0.00101233 0.318929,0.321904 0.480388,-0.00101233 0.798096,0.321904 0.959554,-0.00101233 1.282471,0.321904 1.438721,-0.00101233 1.761638,0.321904 1.917888,-0.00101233 2.240804,0.321904 2.402263,-0.00101233 2.719971,0.321904 2.881429,-0.00101233 3.199138,0.321904 3.360596,-0.00101233 3.678304,0.321904",
    transform: "matrix(0.75,0,0,0.75,561.96002,478.19998)",
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001892,0.00189733 V 3.361272 M -0.481059,0.00189733 V 3.361272 M 0.482483,0.00189733 V 3.361272 M 0.96165,0.00189733 V 3.361272 M -0.3196,3.517522 V -0.321019 M 0.159566,3.517522 V -0.321019 M 0.638733,3.517522 V -0.321019 M 1.1179,3.517522 V -0.321019 M 1.440816,0.00189733 V 3.361272 M 1.919983,0.00189733 V 3.361272 M 2.39915,0.00189733 V 3.361272 m 0.479166,0 V 0.00189733 M 1.602275,3.517522 v -3.838541 m 0.479166,3.838541 v -3.838541 m 0.479167,3.838541 v -3.838541 m -3.359375,3.838541 v -3.838541",
    transform: "matrix(0.75,0,0,0.75,562.56001,478.43998)",
    id: "path259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001221,-8.08e-4 0.317708,-0.161458 0.161459,0.161458 0.317708,-0.161458 0.161458,0.161458 0.322917,-0.161458 0.15625,0.161458 0.322917,-0.161458 0.15625,0.161458 0.322916,-0.161458 0.161459,0.161458 0.317708,-0.161458 0.161458,0.161458 0.317709,-0.161458 0.161458,0.161458 0.317708,-0.161458",
    transform: "matrix(0.75,0,0,0.75,561.96002,471.35998)",
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,6.15333e-4 0.318929,0.318324 0.480388,6.15333e-4 0.798096,0.318324 0.959554,6.15333e-4 1.282471,0.318324 1.438721,6.15333e-4 1.761638,0.318324 1.917888,6.15333e-4 2.240804,0.318324 2.402263,6.15333e-4 2.719971,0.318324 2.881429,6.15333e-4 3.199138,0.318324 3.360596,6.15333e-4 3.678304,0.318324",
    transform: "matrix(0.75,0,0,0.75,561.96002,468.48001)",
    id: "path261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001892,-0.00168333 V 3.357692 M -0.481059,-0.00168333 V 3.357692 M 0.482483,-0.00168333 V 3.357692 M 0.96165,-0.00168333 V 3.357692 M -0.3196,3.51915 V -0.319392 M 0.159566,3.51915 V -0.319392 M 0.638733,3.51915 V -0.319392 M 1.1179,3.51915 v -3.838542 m 0.322916,0.31770867 V 3.357692 M 1.919983,-0.00168333 V 3.357692 M 2.39915,-0.00168333 V 3.357692 m 0.479166,0 V -0.00168333 M 1.602275,3.51915 V -0.319392 M 2.081441,3.51915 V -0.319392 M 2.560608,3.51915 V -0.319392 M -0.798767,3.51915 v -3.838542 m -78.71875,26.880209 v -37.28125",
    transform: "matrix(0.75,0,0,0.75,562.56001,468.72001)",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,613.59896 h -0.3177 l -0.32292,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,613.4375 h 4.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.47917,614.23959 v -0.31771 l -0.16146,-0.16146 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.64062,614.23959 v 82.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.83854,697.28125 h 0.32292 l 0.15625,-0.16145 0.16146,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.83854,697.28125 h -4.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,696.64063 v 0.31771 l 0.32292,0.32291 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.5625,696.64063 v -37.44271 m -0.32292,-6.07812 v -39.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,613.28125 h -0.32292 l -0.31771,0.31771 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,613.1198 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.80208,613.92188 v -0.32292 l -0.16146,-0.16146 -0.16145,-0.15625 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.95833,613.92188 v 83.03646",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,697.59896 h 0.31771 l 0.16145,-0.16146 0.16146,-0.15625 v -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,697.76042 h -5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.40104,696.95834 v 0.32291 l 0.16146,0.15625 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00168333 V -39.1996 M 6.879802,3.039983 V -86.079808 M 10.077718,3.039983 V -86.079808 M -0.318115,-57.7621 H 6.879802 M 2.400635,-78.079808 V -63.1996",
    transform: "matrix(0.75,0,0,0.75,502.67999,522.72001)",
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,632.47917 0.15625,0.47917 0.16145,0.47916 0.47917,0.32292 0.47917,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 670.88021,632.47917 V 620.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.31771,618.88021 -0.47917,0.16146 -0.47917,0.31771 -0.16145,0.47917 -0.15625,0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,619.52084 v -0.16146 l -0.16146,-0.31771 -0.16145,-0.16146 h -0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,619.52084 v 13.76041",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.31771,633.92188 h 0.16146 l 0.16145,-0.16146 0.16146,-0.32292 v -0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00168333 0.482076,-0.157933 1.117493,-0.642308 1.44041,-1.439183 l 0.479166,-0.958334 0.322917,-2.5625 v -1.28125 L 2.081035,-7.522517 1.919576,-8.798558 1.44041,-9.7621 1.117493,-10.558975 0.482076,-11.038142 -0.00229867,-11.1996 l -0.47916633,0.161458 -0.640625,0.479167 -0.317709,0.796875 -0.479166,0.963542 -0.161459,1.276041 -0.161458,1.28125 v 1.28125 l 0.322917,2.5625 0.479166,0.958334 0.317709,0.796875 0.640625,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,504.24,495.72001)",
    id: "path285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,0.00149067 0.480652,-0.159968 0.959819,-0.639134 1.277527,-1.441218 1.600444,-2.399551 1.918152,-3.519343 v -2.5625 L 1.600444,-7.201634 1.277527,-8.159968 0.959819,-8.962051 0.480652,-9.441218 l -0.47916667,-0.15625 -0.47916633,0.15625 -0.484375,0.479167 -0.317709,0.802083 -0.317708,0.958334 -0.322917,1.119791 v 2.5625 l 0.322917,1.119792 0.317708,0.958333 0.317709,0.802084 0.484375,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,504.11998,495.11998)",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,0.00210067 0.481262,0.158351 0.960429,-0.159358 1.439595,-0.799983 1.918762,-1.602066 2.08022,-2.721858 2.397929,-3.997899 V -6.878108 L 2.08022,-8.159358 1.918762,-9.279149 1.439595,-10.081233 0.960429,-10.721858 0.481262,-11.039566 0.00209533,-10.878108",
    transform: "matrix(0.75,0,0,0.75,504.59999,495.59999)",
    id: "path287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-1.98e-4 0.480388,0.640427 0.798096,0.958135 1.282471,1.119594 1.600179,0.801885 2.079346,0.31751 l 0.322917,-0.796875 0.317708,-1.119791 0.161458,-1.28125 0.15625,-1.4375 v -2.880209 l -0.15625,-1.442708 -0.161458,-1.28125 -0.317708,-1.119792 -0.322917,-0.796875 -0.479167,-0.479166 -0.317708,-0.322917 -0.484375,0.161458 -0.317708,0.317709 -0.479167,0.640625",
    transform: "matrix(0.75,0,0,0.75,504.96002,495.83999)",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.11979,649.59896 h -0.80208 m 0.80208,11.52084 h -0.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,675.35938 v 9.28125 h -1.28125 v -9.28125 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,670.23959 v -0.31771 l -0.32292,-0.32292 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,669.59896 h -3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,669.59896 h -0.31771 l -0.32291,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.19792,670.23959 v 19.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.19792,689.76042 v 0.31771 l 0.32291,0.32292 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,690.40105 h 3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,690.40105 h 0.3177 l 0.32292,-0.32292 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 675.68229,689.76042 V 670.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 676.16146,669.76042 V 669.4375 L 676,669.28125 675.83854,669.1198 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,668.95834 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.68229,669.1198 h -0.32292 l -0.3177,0.3177 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.88021,669.76042 v 20.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,690.40105 v 0.3177 l 0.15625,0.16146 0.16145,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.68229,691.19792 h 3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,691.04167 h 0.31771 l 0.32292,-0.32292 v -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 676.31771,690.40105 V 669.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00188667 H -0.162068 V -0.158137 L -6.1e-4,-0.319595 v -0.322917 h -0.161458 l -0.317709,0.484375 0.161459,0.317709 0.15625,0.161458 H -6.1e-4 v -0.640625 0.31770833 H -0.162068 V 0.32103 H 0.160848 L 0.322307,-0.00188667 V -0.481053 L -6.1e-4,-0.642512 h 0.161458 v 0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.51999,466.56001)",
    id: "path307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,0.00250733 H -0.162068 V -0.158951 H -6.1e-4 v -0.479167 l -0.161458,0.15625 -0.317709,0.322917 0.161459,0.479167 0.15625,0.161458 H -6.1e-4 V -0.158951 0.00250733 H -0.162068 V 0.320216 H 0.160848 L 0.322307,0.00250733 V -0.320409 L -6.1e-4,-0.481868 h 0.161458 v 0.322917 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.51999,469.91999)",
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,629.59896 0.48437,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,629.92188 h -0.64062 v -0.64063 l 0.47916,-0.32291 h -0.47916 v -0.31771 h 0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,629.1198 -0.48437,0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,623.19792 -0.47916,-0.15625 v -0.32292 l 0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,623.52084 -0.64062,0.31771 v -0.31771 l 0.47916,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,625.28125 -0.47916,-0.16145 v -0.47917 l 0.47916,-0.16146 h -0.47916 v -0.31771 h 0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,624.64063 -0.48437,0.16146 0.48437,0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,625.59896 h -0.64062 v -0.31771 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00148 V 0.159978 H 0.48228 V 0.477687 H -0.00209533 L -0.158345,0.321437 -0.319804,-0.00148 -0.158345,-0.319188 -0.00209533,-0.480647 H 0.48228 v 0.322917 h -0.48437533 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.40001,470.88002)",
    id: "path317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00121567 V 0.160243 H 0.320821 V -0.00121567 H 0.159363 V 0.477951 H -0.00209533 L -0.158345,0.321701 -0.319804,-0.00121567 -0.158345,-0.318924 -0.00209533,-0.480382 H 0.159363 -0.00209533 0.159363 L 0.48228,-0.157466 0.320821,0.321701 0.159363,0.477951 H 0.320821 V 0.160243 H 0.159363 L 0.320821,-0.00121567 0.159363,-0.157466 h -0.16145833 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.40001,473.03997)",
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,2.08667e-4 V 0.640834 m 0,0.640625 v 0.479166 m 0,0.479167 v 0.479167 m 0,3.041666 v 0.479167 m 0,0.317708 v 0.484375",
    transform: "matrix(0.75,0,0,0.75,506.75999,467.16)",
    id: "path319"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,496.44141 -0.35938,2.8789 v -2.8789 z m 0,0",
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,496.44141 v 2.8789 h -0.35938 z m 0,0",
    id: "path321"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,483.71875 -0.35938,2.88281 v -2.88281 z m 0,0",
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,483.71875 v 2.88281 h -0.35938 z m 0,0",
    id: "path323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,497.39844 -0.35938,2.88281 v -2.88281 z m 0,0",
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,497.39844 v 2.88281 h -0.35938 z m 0,0",
    id: "path325"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,482.87891 -0.35938,2.76171 v -2.76171 z m 0,0",
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,482.87891 v 2.76171 h -0.35938 z m 0,0",
    id: "path327"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,497.76172 -0.36329,2.8789 v -2.8789 z m 0,0",
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,497.76172 v 2.8789 h -0.36329 z m 0,0",
    id: "path329"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,482.51953 -0.36329,2.87891 v -2.87891 z m 0,0",
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,482.51953 v 2.87891 h -0.36329 z m 0,0",
    id: "path331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,497.51953 -0.24219,2.87891 v -2.87891 z m 0,0",
    id: "path332"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,497.51953 v 2.87891 h -0.24219 z m 0,0",
    id: "path333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,482.64062 -0.24219,2.87891 v -2.87891 z m 0,0",
    id: "path334"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,482.64062 v 2.87891 h -0.24219 z m 0,0",
    id: "path335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,497.16016 -0.23829,2.76171 v -2.76171 z m 0,0",
    id: "path336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,497.16016 v 2.76171 h -0.23829 z m 0,0",
    id: "path337"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 503.87891,483.12109 503.64062,486 v -2.87891 z m 0,0",
    id: "path338"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 503.87891,483.12109 V 486 h -0.23829 z m 0,0",
    id: "path339"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,495.83984 -0.12109,2.87891 v -2.87891 z m 0,0",
    id: "path340"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,495.83984 v 2.87891 h -0.12109 z m 0,0",
    id: "path341"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,484.32031 -0.12109,2.87891 v -2.87891 z m 0,0",
    id: "path342"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,484.32031 v 2.87891 h -0.12109 z m 0,0",
    id: "path343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,648.80209 v -3.84375 h -0.47917 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,647.52084 v -3.68229 h -0.47917 v 3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.92187,647.19792 v -3.83854 h -0.48437 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,647.35938 v -3.83854 h -0.32291 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,648 v -3.83854 h -0.31771 V 648 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,649.59896 v -3.83854 h -0.16146 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,661.92188 v 3.83854 h -0.47917 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path350"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,663.19792 v 3.84375 h -0.47917 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.92187,663.6823 v 3.83854 h -0.48437 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,663.35938 v 3.83854 h -0.32291 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,662.88021 v 3.68229 h -0.31771 v -3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,661.1198 v 3.83854 h -0.16146 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.35937,695.52084 h 0.32292 l 0.15625,-0.16146 L 676,695.19792 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.35937,695.52084 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,694.88021 v 0.31771 l 0.16146,0.16146 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,694.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,692.95834 h -0.32292 l -0.15625,0.16146 -0.16146,0.16145 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,692.95834 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,693.59896 v -0.31771 l -0.16146,-0.16145 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,693.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,695.19792 0.16145,-0.15625 0.16146,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,695.19792 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.5625,694.88021 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,694.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,693.28125 -0.16146,0.15625 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,693.1198 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,693.59896 -0.16146,-0.16146 -0.16145,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,693.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,695.52084 h 0.32292 l 0.15625,-0.16146 0.16146,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,695.52084 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,694.88021 v 0.31771 l 0.32292,0.32292 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,694.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,692.95834 h -0.3177 l -0.32292,0.32291 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,692.95834 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.59896,693.59896 v -0.31771 l -0.16146,-0.16145 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path378"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.59896,693.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path379"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,695.19792 0.31771,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path380"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,695.19792 h -1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,694.88021 0.15625,0.16146 0.16145,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.88021,694.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,693.28125 -0.16145,0.15625 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,693.1198 h 1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.11979,693.59896 -0.31771,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.28125,693.59896 v 1.28125 m -3.35938,-84 4.64063,0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.95833,614.40105 -0.15625,-0.64063 -0.16146,-0.64062 -0.32291,-0.47917 -0.63542,-0.47917 L 675.19792,612 674.5625,611.83855",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 677.11979,614.40105 v 81.91666",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.5625,698.88021 0.63542,-0.16146 0.48437,-0.15625 0.63542,-0.48437 0.32291,-0.47917 0.16146,-0.64062 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,2.08667e-4 -4.638123,1.12 m -0.161458,-80.479166 h 0.161458 m -0.161458,71.838541 h 0.161458 m 0,-80.479166 V 1.12 m -0.161458,-80.479166 v 71.838541 m 81.4375,-2.401041 h -1.916667 m 0.640625,-2.557292 h -0.640625",
    transform: "matrix(0.75,0,0,0.75,505.92,524.16)",
    id: "path391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,0.002304 0.158142,0.481471 0.3196,0.960637 0.798767,1.122096 1.277934,1.278346 1.762309,1.122096 2.241475,0.960637 2.397725,0.481471 2.559184,0.002304",
    transform: "matrix(0.75,0,0,0.75,562.43999,515.75999)",
    id: "path392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,4.12e-4 -0.162272,-0.478755 l -0.15625,-0.479166 -0.479166,-0.161459 -0.484375,-0.161458 -0.958334,0.322917 -0.161458,0.479166 -0.15625,0.479167",
    transform: "matrix(0.75,0,0,0.75,564.35999,466.32)",
    id: "path393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -8.13333e-4,0.002304 v -46.401042 m 0,-3.520833 v -9.442708 m 0,-3.515625 v -3.041667 M -2.558105,0.002304 v -46.401042 m 0,-3.520833 v -9.442708 m 0,-3.515625 v -3.041667 m -1.119792,-10.880208 -4.484375,8 m -1.916666,3.520833 -7.520834,13.916667 m -1.921875,3.520833 -7.520833,13.760417 m -1.916667,3.520833 -7.682291,13.921875 m -1.760417,3.520833 -7.677083,13.755209",
    transform: "matrix(0.75,0,0,0.75,564.35999,515.75999)",
    id: "path394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 704.47917,691.83855 700.16146,700",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,5.33333e-6 -4.48228,-8.161453 m -1.916666,-3.520833 -7.520834,-13.755209 m -1.921875,-3.520833 -7.520833,-13.921875 m -1.916667,-3.520833 -7.682291,-13.760417 m -1.760417,-3.520833 -7.677083,-13.916667",
    transform: "matrix(0.75,0,0,0.75,561.59999,525)",
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 704.47917,618.88021 -4.31771,-8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 748.80208,521.76042 v 89.11979 h -78.88021 v -89.11979 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 700.16146,610.88021 V 521.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path399"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001221,-8.08e-4 0.317708,-0.317708 0.161459,0.317708 0.317708,-0.317708 0.161458,0.317708 0.322917,-0.317708 0.15625,0.317708 0.322917,-0.317708 0.15625,0.317708 0.322916,-0.317708 0.161459,0.317708 0.317708,-0.317708 0.161458,0.317708 0.317709,-0.317708 0.161458,0.317708 0.317708,-0.317708",
    transform: "matrix(0.75,0,0,0.75,561.96002,414.35998)",
    id: "path400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,-8.08e-4 0.318929,0.322109 0.480388,-8.08e-4 0.798096,0.322109 0.959554,-8.08e-4 1.282471,0.322109 1.438721,-8.08e-4 1.761638,0.322109 1.917888,-8.08e-4 2.240804,0.322109 2.402263,-8.08e-4 2.719971,0.322109 2.881429,-8.08e-4 3.199138,0.322109 3.360596,-8.08e-4 3.678304,0.322109",
    transform: "matrix(0.75,0,0,0.75,561.96002,411.35998)",
    id: "path401"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001892,0.00210067 V 3.361476 M -0.481059,0.00210067 V 3.361476 M 0.482483,0.00210067 V 3.361476 M 0.96165,0.00210067 V 3.361476 M -0.3196,3.679184 v -4 m 0.479166,4 v -4 m 0.479167,4 v -4 m 0.479167,4 v -4 M 1.440816,0.00210067 V 3.361476 M 1.919983,0.00210067 V 3.361476 M 2.39915,0.00210067 V 3.361476 m 0.479166,0 V 0.00210067 M 1.602275,3.679184 v -4 m 0.479166,4 v -4 m 0.479167,4 v -4 m -3.359375,4 v -4",
    transform: "matrix(0.75,0,0,0.75,562.56001,411.59999)",
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,8.18667e-4 0.318929,-0.322098 0.480388,8.18667e-4 0.798096,-0.322098 0.959554,8.18667e-4 1.282471,-0.322098 1.438721,8.18667e-4 1.761638,-0.322098 1.917888,8.18667e-4 2.240804,-0.322098 2.402263,8.18667e-4 2.719971,-0.322098 2.881429,8.18667e-4 3.199138,-0.322098 3.360596,8.18667e-4 3.678304,-0.322098",
    transform: "matrix(0.75,0,0,0.75,561.96002,404.64001)",
    id: "path403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,8.18667e-4 0.318929,0.318527 0.480388,8.18667e-4 0.798096,0.318527 0.959554,8.18667e-4 1.282471,0.318527 1.438721,8.18667e-4 1.761638,0.318527 1.917888,8.18667e-4 2.240804,0.318527 2.402263,8.18667e-4 2.719971,0.318527 2.881429,8.18667e-4 3.199138,0.318527 3.360596,8.18667e-4 3.678304,0.318527",
    transform: "matrix(0.75,0,0,0.75,561.96002,401.64001)",
    id: "path404"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001892,-0.00148 V 3.357895 M -0.481059,-0.00148 V 3.357895 M 0.482483,-0.00148 V 3.357895 M 0.96165,-0.00148 V 3.357895 M -0.3196,3.680812 v -4 m 0.479166,4 v -4 m 0.479167,4 v -4 m 0.479167,4 v -4 M 1.440816,-0.00148 V 3.357895 M 1.919983,-0.00148 V 3.357895 M 2.39915,-0.00148 v 3.359375 m 0.479166,0 V -0.00148 M 1.602275,3.680812 v -4 m 0.479166,4 v -4 m 0.479167,4 v -4 m -3.359375,4 v -4 m -78.71875,27.041666 V -10.72023",
    transform: "matrix(0.75,0,0,0.75,562.56001,401.88002)",
    id: "path405"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,524.47917 h -0.3177 l -0.32292,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,524.31771 h 4.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.47917,525.1198 v -0.31771 l -0.16146,-0.16146 -0.15625,-0.16146 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.64062,525.1198 v 82.40104",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.83854,608.16146 h 0.32292 L 676.31771,608 l 0.16146,-0.16145 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.83854,608.31771 h -4.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,607.52084 v 0.31771 l 0.32292,0.32291 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 670.5625,607.52084 V 570.07813 M 670.23958,564 v -39.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path413"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,524.16146 h -0.32292 l -0.31771,0.31771 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,524 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.80208,524.80209 v -0.32292 l -0.16146,-0.16146 -0.16145,-0.15625 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.95833,524.80209 v 83.03646",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,608.47917 h 0.31771 l 0.16145,-0.16146 0.16146,-0.15625 v -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,608.64063 h -5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.40104,607.83855 v 0.32291 l 0.16146,0.15625 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path420"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00148 V -39.199397 M 6.879802,3.040187 V -86.079605 M 10.077718,3.040187 V -86.079605 M -0.318115,-57.761897 H 6.879802 M 2.400635,-78.079605 v 15.041667",
    transform: "matrix(0.75,0,0,0.75,502.67999,455.88002)",
    id: "path421"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,543.35938 0.15625,0.47917 0.16145,0.47916 0.47917,0.32292 0.47917,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path422"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 670.88021,543.35938 V 531.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.31771,529.76042 -0.47917,0.16146 -0.47917,0.31771 -0.16145,0.47916 -0.15625,0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,530.40105 v -0.16146 l -0.16146,-0.31771 -0.16145,-0.16146 h -0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,530.40105 v 13.76041",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path426"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.31771,544.80209 h 0.16146 l 0.16145,-0.16146 0.16146,-0.32292 v -0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path427"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00148 0.482076,-0.15773 1.117493,-0.642105 1.44041,-1.43898 1.919576,-2.402522 2.081035,-3.678563 2.242493,-4.959813 v -1.28125 L 2.081035,-7.522313 1.919576,-8.798355 1.44041,-9.761897 l -0.322917,-0.796875 -0.635417,-0.479166 -0.48437467,-0.161459 -0.47916633,0.161459 -0.640625,0.479166 -0.317709,0.796875 -0.479166,0.963542 -0.161459,1.276042 -0.161458,1.28125 v 1.28125 l 0.161458,1.28125 0.161459,1.276041 0.479166,0.963542 0.317709,0.796875 0.640625,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,504.24,428.88002)",
    id: "path428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,0.001694 0.480652,-0.159764 0.959819,-0.638931 1.277527,-1.441014 1.600444,-2.399348 1.918152,-3.519139 v -2.5625 L 1.600444,-7.201431 1.277527,-8.159764 0.959819,-8.961848 0.480652,-9.441014 0.00148533,-9.602473 -0.477681,-9.441014 l -0.484375,0.479166 -0.317709,0.802084 -0.317708,0.958333 -0.322917,1.119792 v 2.5625 l 0.322917,1.119791 0.317708,0.958334 0.317709,0.802083 0.484375,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,504.11998,428.27998)",
    id: "path429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,0.002304 0.481262,0.158554 0.960429,-0.159154 1.439595,-0.799779 1.918762,-1.601863 2.08022,-2.721654 2.397929,-3.997696 V -6.877904 L 2.08022,-8.159154 1.918762,-9.278946 1.439595,-10.081029 0.960429,-10.721654 0.481262,-11.039363 0.00209533,-10.877904",
    transform: "matrix(0.75,0,0,0.75,504.59999,428.75999)",
    id: "path430"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001221,5.33333e-6 0.480388,0.64063 0.798096,0.958339 1.282471,1.119797 1.600179,0.802089 2.079346,0.317714 l 0.322917,-0.796875 0.317708,-1.119792 0.161458,-1.28125 0.15625,-1.4375 V -7.197911 L 2.881429,-8.64062 2.719971,-9.92187 2.402263,-11.041661 2.079346,-11.838536 1.600179,-12.317703 1.282471,-12.64062 l -0.484375,0.161459 -0.317708,0.317708 -0.479167,0.640625",
    transform: "matrix(0.75,0,0,0.75,504.96002,429)",
    id: "path431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.11979,560.64063 h -0.80208 M 673.11979,572 h -0.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,586.23959 v 9.44271 h -1.28125 v -9.44271 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path433"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,581.1198 v -0.31771 l -0.32292,-0.32292 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,580.47917 h -3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path435"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,580.47917 h -0.31771 l -0.32291,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.19792,581.1198 v 19.68229",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.19792,600.80209 v 0.31771 l 0.16145,0.16145 0.16146,0.15625 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,601.4375 h 3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,601.4375 h 0.3177 l 0.16146,-0.15625 0.16146,-0.16145 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path440"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 675.68229,600.80209 V 581.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.16146,580.64063 v -0.32292 L 676,580.16146 675.83854,580 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,579.83855 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.68229,580 h -0.32292 l -0.3177,0.31771 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.88021,580.64063 v 20.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,601.28125 v 0.31771 l 0.15625,0.16146 0.16145,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.68229,602.07813 h 3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,601.92188 h 0.31771 l 0.32292,-0.32292 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 676.31771,601.28125 V 580.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00168333 H -0.162068 V -0.157933 H -6.1e-4 v -0.484375 l -0.161458,0.161458 -0.317709,0.322917 0.161459,0.479166 0.15625,0.15625 H -6.1e-4 v -0.635416 0.15624967 H -0.162068 V 0.321233 H 0.160848 L 0.322307,-0.00168333 V -0.48085 L -6.1e-4,-0.642308 0.160848,-0.48085 v 0.322917 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.51999,399.72001)",
    id: "path450"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00101233 H -0.162068 V -0.318721 H -6.1e-4 v -0.322916 h -0.161458 l -0.317709,0.322916 0.161459,0.479167 0.15625,0.161458 H -6.1e-4 v -0.640625 0.15625 l -0.161458,0.16145867 V 0.321904 H -6.1e-4 L 0.160848,0.160446 0.322307,-0.162471 V -0.480179 L -6.1e-4,-0.641637 h 0.161458 v 0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.51999,403.19998)",
    id: "path451"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,540.47917 h 0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,540.80209 h -0.64062 v -0.48438 l 0.47916,-0.47916 L 675.04167,540 v -0.47916 h 0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,540.16146 -0.48437,0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,534.23959 -0.47916,-0.31771 v -0.32292 l 0.64062,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path455"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,534.40105 -0.64062,0.3177 v -0.3177 l 0.47916,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 675.52083,536.16146 675.04167,536 v -0.3177 l 0.47916,-0.32292 h -0.47916 v -0.31771 h 0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,535.6823 -0.48437,0.15625 0.48437,0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,536.47917 -0.64062,0.16146 v -0.47917 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path459"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00121567 V 0.160243 H 0.48228 V 0.477951 H -0.00209533 L -0.158345,0.321701 -0.319804,-0.00121567 -0.158345,-0.318924 -0.00209533,-0.480382 H 0.48228 v 0.322916 h -0.48437533 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.40001,404.03997)",
    id: "path460"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00101233 V 0.160446 H 0.320821 V -0.00101233 H 0.159363 V 0.478154 H -0.00209533 L -0.158345,0.321904 -0.319804,-0.00101233 -0.158345,-0.162471 -0.00209533,-0.480179 H 0.159363 -0.00209533 0.159363 l 0.161458,0.161458 0.161459,0.15625 -0.161459,0.640625 H 0.159363 0.320821 V 0.160446 H 0.159363 L 0.320821,-0.00101233 0.159363,-0.162471 h -0.16145833 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,506.40001,406.19998)",
    id: "path461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,0.00189733 V 0.481064 m 0,0.640625 v 0.640625 m 0,0.317708 v 0.479167 m 0,3.041667 v 0.640625 m 0,0.317708 v 0.322917",
    transform: "matrix(0.75,0,0,0.75,506.75999,400.43998)",
    id: "path462"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,429.71875 -0.35938,2.76172 v -2.76172 z m 0,0",
    id: "path463"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,429.71875 v 2.76172 h -0.35938 z m 0,0",
    id: "path464"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,417 -0.35938,2.76172 V 417 Z m 0,0",
    id: "path465"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 507,417 v 2.76172 h -0.35938 z m 0,0",
    id: "path466"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,430.55859 -0.35938,2.88282 v -2.88282 z m 0,0",
    id: "path467"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,430.55859 v 2.88282 h -0.35938 z m 0,0",
    id: "path468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,416.03906 -0.35938,2.88281 v -2.88281 z m 0,0",
    id: "path469"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 506.28125,416.03906 v 2.88281 h -0.35938 z m 0,0",
    id: "path470"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,430.92187 -0.36329,2.87891 v -2.87891 z m 0,0",
    id: "path471"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,430.92187 v 2.87891 h -0.36329 z m 0,0",
    id: "path472"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,415.67969 -0.36329,2.8789 v -2.8789 z m 0,0",
    id: "path473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 505.44141,415.67969 v 2.8789 h -0.36329 z m 0,0",
    id: "path474"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,430.80078 -0.24219,2.75781 v -2.75781 z m 0,0",
    id: "path475"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,430.80078 v 2.75781 h -0.24219 z m 0,0",
    id: "path476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,415.92187 -0.24219,2.75782 v -2.75782 z m 0,0",
    id: "path477"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 504.60156,415.92187 v 2.75782 h -0.24219 z m 0,0",
    id: "path478"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,430.32031 -0.23829,2.87891 v -2.87891 z m 0,0",
    id: "path479"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,430.32031 v 2.87891 h -0.23829 z m 0,0",
    id: "path480"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,416.28125 -0.23829,2.87891 v -2.87891 z m 0,0",
    id: "path481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.87891,416.28125 v 2.87891 h -0.23829 z m 0,0",
    id: "path482"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,429.12109 -0.12109,2.75782 v -2.75782 z m 0,0",
    id: "path483"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,429.12109 v 2.75782 h -0.12109 z m 0,0",
    id: "path484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,417.60156 -0.12109,2.75781 v -2.75781 z m 0,0",
    id: "path485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 503.28125,417.60156 v 2.75781 h -0.12109 z m 0,0",
    id: "path486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 676,559.6823 V 556 h -0.47917 v 3.6823 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,558.5625 v -3.84375 h -0.47917 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.92187,558.07813 v -3.83854 h -0.48437 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,558.23959 v -3.67709 h -0.32291 v 3.67709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path490"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,558.88021 v -3.83854 h -0.31771 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,560.47917 v -3.67708 h -0.16146 v 3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,572.95834 v 3.68229 h -0.47917 v -3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,574.07813 v 3.84375 h -0.47917 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.92187,574.5625 v 3.83855 h -0.48437 v -3.83855 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,574.40105 v 3.67708 h -0.32291 v -3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.83854,573.76042 v 3.83854 h -0.31771 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,572.16146 v 3.67709 h -0.16146 v -3.67709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.35937,606.40105 h 0.32292 l 0.15625,-0.16146 L 676,606.07813 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.35937,606.40105 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,605.76042 v 0.31771 l 0.16146,0.16146 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,605.76042 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path502"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,603.83855 h -0.32292 L 674.5625,604 l -0.16146,0.16146 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.04167,603.83855 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,604.47917 v -0.31771 L 675.83854,604 l -0.15625,-0.16145 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,604.47917 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,606.07813 0.16145,-0.15625 0.16146,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.19792,606.23959 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.5625,605.76042 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path509"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.40104,605.76042 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path510"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,604.16146 -0.16146,0.15625 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path511"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.88021,604.16146 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.52083,604.47917 -0.16146,-0.16146 -0.16145,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 675.68229,604.47917 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path514"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,606.40105 h 0.32292 l 0.15625,-0.16146 0.16146,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.95833,606.40105 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,605.76042 v 0.31771 l 0.32292,0.32292 h 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.71875,605.76042 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,603.83855 h -0.3177 l -0.32292,0.32291 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,603.83855 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path520"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.59896,604.47917 v -0.31771 L 673.4375,604 l -0.15625,-0.16145 h -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.59896,604.47917 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path522"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,606.07813 0.31771,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 672.80208,606.23959 h -1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.04167,605.76042 0.15625,0.16146 0.16145,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 670.88021,605.76042 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,604.16146 -0.16145,0.15625 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path527"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 671.35937,604.16146 h 1.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.11979,604.47917 -0.31771,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 673.28125,604.47917 v 1.28125 m -3.35938,-84 4.64063,0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path530"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676.95833,525.28125 -0.15625,-0.64062 -0.16146,-0.64063 -0.32291,-0.47916 -0.63542,-0.47917 -0.48437,-0.16146 -0.63542,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 677.11979,525.28125 v 81.91667",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 674.5625,609.76042 0.63542,-0.16146 0.48437,-0.16146 0.63542,-0.47916 0.32291,-0.47917 0.16146,-0.64062 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00189733 -4.638123,0.960231 m -0.161458,-80.479167 h 0.161458 m -0.161458,71.838542 h 0.161458 m 0,-80.479167 V 0.960231 m -0.161458,-80.479167 v 71.838542 m 81.4375,-2.401042 h -1.916667 m 0.640625,-2.557292 h -0.640625",
    transform: "matrix(0.75,0,0,0.75,505.92,457.43998)",
    id: "path534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,0.00250733 0.158142,0.481674 0.3196,0.960841 0.798767,1.122299 1.277934,1.278549 1.762309,1.122299 2.241475,0.960841 2.397725,0.481674 2.559184,0.00250733",
    transform: "matrix(0.75,0,0,0.75,562.43999,448.91999)",
    id: "path535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,6.15333e-4 -0.162272,-0.478551 l -0.15625,-0.479167 -0.479166,-0.161458 -0.484375,-0.161459 -0.958334,0.322917 -0.161458,0.479167 -0.15625,0.479166333",
    transform: "matrix(0.75,0,0,0.75,564.35999,399.48001)",
    id: "path536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,0.00250733 V -46.242284 m 0,-3.677084 v -9.28125 m 0,-3.677083 v -3.041667 M -2.558105,0.00250733 V -46.242284 m 0,-3.677084 v -9.28125 m 0,-3.677083 v -3.041667 m -1.119792,-10.880208 -4.484375,8.161458 m -1.916666,3.359375 -7.520834,13.916667 m -1.921875,3.520833 -7.520833,13.921875 m -1.916667,3.359375 -7.682291,13.921875 m -1.760417,3.515625 -7.677083,13.921875",
    transform: "matrix(0.75,0,0,0.75,564.35999,448.91999)",
    id: "path537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 704.47917,602.71875 -4.31771,8.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,2.08667e-4 -4.48228,-8.16125 M -6.398946,-11.520625 -13.91978,-25.4425 M -15.841655,-28.958125 -23.362488,-42.88 m -1.916667,-3.359375 -7.682291,-13.921875 m -1.760417,-3.520833 -7.677083,-13.916667",
    transform: "matrix(0.75,0,0,0.75,561.59999,458.16)",
    id: "path539"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 704.47917,529.92188 -4.31771,-8.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 479.04167,521.59896 v -89.11979 h 78.71875 v 89.11979 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path541"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 527.68229,432.47917 v 89.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,2.08667e-4 -0.320415,0.317917 -0.638123,2.08667e-4 -0.799581,0.317917 -1.122498,2.08667e-4 -1.278748,0.317917 -1.601665,2.08667e-4 -1.757915,0.317917 -2.080831,2.08667e-4 -2.24229,0.317917 -2.559998,2.08667e-4 -2.721456,0.317917 -3.039165,2.08667e-4 -3.200623,0.317917 -3.518331,2.08667e-4 -3.67979,0.317917",
    transform: "matrix(0.75,0,0,0.75,358.92,368.16)",
    id: "path543"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,2.08667e-4 -0.320415,-0.3175 -0.638123,2.08667e-4 -0.799581,-0.3175 -1.122498,2.08667e-4 -1.278748,-0.3175 -1.601665,2.08667e-4 -1.757915,-0.3175 -2.080831,2.08667e-4 -2.24229,-0.3175 -2.559998,2.08667e-4 -2.721456,-0.3175 -3.039165,2.08667e-4 -3.200623,-0.3175 -3.518331,2.08667e-4 -3.67979,-0.3175",
    transform: "matrix(0.75,0,0,0.75,358.92,371.16)",
    id: "path544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00250733 V -3.362076 M 0.479573,0.00250733 V -3.362076 M -0.47876,0.00250733 V -3.362076 M -0.957927,0.00250733 V -3.362076 m 1.119792,-0.317708 v 4 m -0.484375,-4 v 4 m -0.479167,-4 v 4 m -0.479166,-4 v 4 M -1.442302,0.00250733 V -3.362076 M -1.921468,0.00250733 V -3.362076 M -2.400635,0.00250733 V -3.362076 m -0.479167,0 V 0.00250733 M -1.76001,-3.679784 v 4 m -0.479167,-4 v 4 m -0.479166,-4 v 4 m 3.520833,-4 v 4",
    transform: "matrix(0.75,0,0,0.75,358.32001,370.91999)",
    id: "path545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.001449 -0.320415,0.321468 -0.638123,-0.001449 -0.799581,0.321468 -1.122498,-0.001449 -1.278748,0.321468 -1.601665,-0.001449 -1.757915,0.321468 -2.080831,-0.001449 -2.24229,0.321468 -2.559998,-0.001449 -2.721456,0.321468 -3.039165,-0.001449 -3.200623,0.321468 -3.518331,-0.001449 -3.67979,0.321468",
    transform: "matrix(0.75,0,0,0.75,358.92,377.87999)",
    id: "path546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.002502,-0.001449 -0.322917,-0.317708 -0.317708,0.317708 -0.161458,-0.317708 -0.322917,0.317708 -0.15625,-0.317708 -0.322917,0.317708 -0.15625,-0.317708 -0.322916,0.317708 -0.161459,-0.317708 -0.317708,0.317708 -0.161458,-0.317708 -0.317709,0.317708 -0.161458,-0.317708 -0.317708,0.317708 -0.161459,-0.317708",
    transform: "matrix(0.75,0,0,0.75,358.92,380.87999)",
    id: "path547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,8.49667e-4 V -3.358525 M 0.479573,8.49667e-4 V -3.358525 M -0.47876,8.49667e-4 V -3.358525 M -0.957927,8.49667e-4 V -3.358525 m 1.119792,-0.322917 v 4 m -0.484375,-4 v 4 m -0.479167,-4 v 4 m -0.479166,-4 v 4 M -1.442302,8.49667e-4 V -3.358525 M -1.921468,8.49667e-4 V -3.358525 M -2.400635,8.49667e-4 V -3.358525 m -0.479167,0 V 8.49667e-4 M -1.76001,-3.681442 v 4 m -0.479167,-4 v 4 m -0.479166,-4 v 4 m 3.520833,-4 v 4 M 79.359782,-26.7179 v 37.4375",
    transform: "matrix(0.75,0,0,0.75,358.32001,380.63999)",
    id: "path548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,518.88021 h 0.32291 l 0.31771,-0.31771 v -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path549"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.31771,519.04167 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,518.23959 v 0.32291 l 0.16146,0.15625 0.16146,0.16146 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 551.19792,518.23959 V 435.83855",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,435.19792 h -0.31771 l -0.32292,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,435.04167 h 4.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,435.83855 v -0.31771 l -0.15625,-0.16146 -0.16146,-0.16146 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.11979,435.83855 v 37.4427 m 0.47917,6.07813 v 39.20312",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,519.19792 h 0.31771 l 0.16146,-0.15625 0.15625,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,519.35938 h -5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.88021,518.5625 v 0.31771 l 0.31771,0.31771 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,518.5625 V 435.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,434.88021 h -0.32291 l -0.15625,0.16146 -0.16146,0.15625 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,434.71875 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.4375,435.52084 v -0.32292 l -0.31771,-0.31771 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,8.49667e-4 V 39.198766 M -7.037476,-3.040817 V 86.078975 M -10.240601,-3.040817 V 86.078975 M 0.160441,57.761266 h -7.197917 m 4.479167,20.317709 V 63.042516",
    transform: "matrix(0.75,0,0,0.75,418.19998,326.63999)",
    id: "path564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,500 -0.32291,-0.95833 -0.47917,-0.32292 -0.47917,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,500 v 12.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,513.59896 0.47917,-0.16146 0.47917,-0.3177 0.32291,-0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,512.95834 v 0.16146 l 0.16146,0.3177 0.15625,0.16146 h 0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 554.71875,512.95834 V 499.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path569"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,498.5625 h -0.16145 l -0.15625,0.15625 -0.16146,0.32292 v 0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path570"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,8.49667e-4 -0.479777,0.162308 -1.120402,0.641475 -1.43811,1.43835 l -0.484375,0.963541 -0.15625,1.276042 -0.161458,1.28125 v 1.28125 l 0.161458,1.28125 0.15625,1.276042 0.484375,0.963541 0.317708,0.796875 0.640625,0.484375 0.479167,0.15625 0.479167,-0.15625 L 1.119182,10.558141 1.442098,9.761266 1.921265,8.797725 2.077515,7.521683 2.238973,6.240433 V 4.959183 L 2.077515,3.677933 1.921265,2.401891 1.442098,1.43835 1.119182,0.641475 0.478557,0.162308 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.51999,353.63999)",
    id: "path571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.13333e-4,-0.00229333 -0.478353,0.159165 -0.95752,0.638332 -1.280437,1.440415 -1.598145,2.398748 -1.921062,3.51854 v 2.5625 l 0.322917,1.119792 0.317708,0.958333 0.322917,0.802083 0.479167,0.479167 L 8.13333e-4,9.601873 0.47998,9.440415 0.959147,8.961248 1.282063,8.159165 1.599772,7.200832 1.91748,6.08104 V 3.51854 L 1.599772,2.398748 1.282063,1.440415 0.959147,0.638332 0.47998,0.159165 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.64001,354.24)",
    id: "path572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,0.002304 -0.478963,-0.159154 -0.95813,0.158554 l -0.484375,0.640625 -0.479167,0.802083 -0.15625,1.119792 -0.322916,1.28125 v 2.880208 l 0.322916,1.276042 0.15625,1.119792 0.479167,0.802083 0.484375,0.640625 0.479167,0.317708 0.479166333,-0.15625",
    transform: "matrix(0.75,0,0,0.75,416.16,353.75999)",
    id: "path573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00101767,-6.04667e-4 -0.478149,-0.64123 -0.801066,-0.958938 -1.280232,-1.120396 -1.597941,-0.79748 -2.082316,-0.318313 -2.400024,0.478562 -2.717732,1.598354 -2.879191,2.879604 -3.040649,4.322312 V 7.20252 l 0.161458,1.4375 0.161459,1.28125 0.317708,1.119792 0.317708,0.796875 0.802084,0.802083 0.479166,-0.161458 0.322917,-0.317708 0.47916667,-0.640625",
    transform: "matrix(0.75,0,0,0.75,415.80002,353.51999)",
    id: "path574"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,482.71875 h 0.79687 m -0.79687,-11.35937 h 0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path575"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,457.1198 v -9.4375 h 1.27604 v 9.4375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path576"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,462.23959 v 0.32291 l 0.16146,0.15625 0.15625,0.16146 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.64062,462.88021 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,462.88021 h 0.31771 l 0.16146,-0.16146 0.16145,-0.15625 v -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.64062,462.23959 V 442.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path580"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,442.5625 v -0.32291 l -0.16145,-0.16146 -0.16146,-0.15625 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path581"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,441.92188 h -3.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path582"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.64062,441.92188 h -0.32291 L 552,442.23959 v 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,442.5625 v 19.67709",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path584"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,462.71875 v 0.32292 l 0.16146,0.15625 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path585"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.16146,463.52084 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,463.35938 h 0.31771 l 0.16146,-0.16146 0.16145,-0.15625 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path587"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.80208,462.71875 V 442.07813",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,442.07813 v -0.31771 l -0.32291,-0.32292 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path589"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,441.28125 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path590"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,441.4375 h -0.32292 l -0.15625,0.16146 -0.16146,0.16146 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path591"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,442.07813 v 20.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path592"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,0.001053 H 0.15916 V 0.162511 H -0.00229867 V 0.641678 H 0.15916 L 0.320618,0.48022 0.482076,0.162511 V -0.321864 L 0.15916,-0.478114 h -0.16145867 v 0.15625 L 0.15916,-0.160405 V 0.162511 H -0.00229867 V 0.001053 H 0.15916 v -0.322917 h -0.317709 l -0.161458,0.322917 0.161458,0.479167 0.15625033,0.161458 V 0.48022 L -0.158549,0.318761 -0.00229867,0.162511 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,382.79999)",
    id: "path593"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,4.12e-4 H 0.15916 V 0.31812 H -0.00229867 V 0.641037 H 0.320618 L 0.482076,0.31812 V -0.161046 L 0.15916,-0.322505 H -0.00229867 L 0.15916,-0.161046 V 0.31812 H -0.00229867 V 0.16187 L 0.15916,4.12e-4 v -0.322917 l -0.317709,0.161459 -0.161458,0.322916 0.161458,0.317709 0.15625033,0.161458 H 0.15916 -0.00229867 L -0.158549,0.479579 -0.00229867,0.16187 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,379.32)",
    id: "path594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,502.88021 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,502.5625 h 0.64062 v 0.47917 l -0.48437,0.47917 0.48437,-0.16146 v 0.47917 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,503.19792 0.31771,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,509.1198 0.64062,0.3177 v 0.32292 l -0.64062,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,508.80209 0.64062,-0.16146 v 0.31771 l -0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,507.19792 0.64062,0.16146 v 0.32292 L 552.16146,508 h 0.64062 v 0.31771 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,507.6823 0.31771,-0.16146 -0.31771,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path601"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,506.88021 0.64062,-0.16146 v 0.47917 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path602"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,6.15333e-4 -0.160848,-0.160843 H -0.478557 V -0.478551 H 6.1e-4 l 0.161458,0.15625 V 0.318324 L 6.1e-4,0.479782 H -0.478557 V 0.162074 h 0.317709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,378.48001)",
    id: "path603"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,4.12e-4 -0.160848,-0.161046 H -0.478557 V 4.12e-4 h 0.317709 v -0.479167 l 0.322916,0.15625 V 0.16187 L 6.1e-4,0.479579 H -0.160848 L -0.478557,0.31812 -0.640015,0.16187 -0.478557,-0.478755 h 0.317709 -0.161459 v 0.317709 h 0.161459 -0.161459 V 4.12e-4 l 0.161459,0.161458 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,376.32)",
    id: "path604"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,-0.00249667 V -0.637913 m 0,-0.484375 v -0.635417 m 0,-0.322917 v -0.479166 m 0,-3.041667 V -6.24208 m 0,-0.317708 v -0.317709",
    transform: "matrix(0.75,0,0,0.75,414.11998,382.08)",
    id: "path605"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,352.80078 0.24218,-2.76172 v 2.76172 z m 0,0",
    id: "path606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,352.80078 v -2.76172 h 0.24218 z m 0,0",
    id: "path607"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,365.51953 0.24218,-2.75781 v 2.75781 z m 0,0",
    id: "path608"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,365.51953 v -2.75781 h 0.24218 z m 0,0",
    id: "path609"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,351.96094 0.23828,-2.88282 v 2.88282 z m 0,0",
    id: "path610"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,351.96094 v -2.88282 h 0.23828 z m 0,0",
    id: "path611"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,366.48047 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path612"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,366.48047 v -2.87891 h 0.23828 z m 0,0",
    id: "path613"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,351.60156 0.23828,-2.88281 v 2.88281 z m 0,0",
    id: "path614"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,351.60156 v -2.88281 h 0.23828 z m 0,0",
    id: "path615"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,366.83984 0.23828,-2.8789 v 2.8789 z m 0,0",
    id: "path616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,366.83984 v -2.8789 h 0.23828 z m 0,0",
    id: "path617"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,351.71875 0.23828,-2.75781 v 2.75781 z m 0,0",
    id: "path618"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,351.71875 v -2.75781 h 0.23828 z m 0,0",
    id: "path619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,366.60156 0.23828,-2.76172 v 2.76172 z m 0,0",
    id: "path620"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,366.60156 v -2.76172 h 0.23828 z m 0,0",
    id: "path621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,352.19922 0.12109,-2.87891 v 2.87891 z m 0,0",
    id: "path622"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,352.19922 v -2.87891 h 0.12109 z m 0,0",
    id: "path623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,366.23828 0.12109,-2.87891 v 2.87891 z m 0,0",
    id: "path624"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,366.23828 v -2.87891 h 0.12109 z m 0,0",
    id: "path625"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,353.39844 0.11719,-2.75782 v 2.75782 z m 0,0",
    id: "path626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,353.39844 v -2.75782 h 0.11719 z m 0,0",
    id: "path627"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,364.92187 0.11719,-2.76171 v 2.76171 z m 0,0",
    id: "path628"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,364.92187 v -2.76171 h 0.11719 z m 0,0",
    id: "path629"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,483.6823 v 3.67708 h 0.32292 v -3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path630"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,484.80209 v 3.83854 h 0.31771 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path631"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,485.28125 v 3.83855 h 0.31771 v -3.83855 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,485.1198 v 3.68229 h 0.31771 v -3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,484.47917 v 3.83854 h 0.16146 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,482.88021 v 3.68229 h 0.15625 v -3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,470.40105 v -3.6823 h 0.32292 v 3.6823 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,469.28125 v -3.84375 h 0.31771 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path637"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,468.80209 v -3.84375 h 0.31771 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path638"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,468.95834 v -3.67709 h 0.31771 v 3.67709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path639"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,469.59896 v -3.83854 h 0.16146 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path640"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,471.19792 v -3.67708 h 0.15625 v 3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path641"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.31771,436.95834 H 552 l -0.16146,0.16146 -0.15625,0.16145 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path642"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.31771,436.95834 h 0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path643"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,437.59896 v -0.31771 l -0.15625,-0.16145 -0.16146,-0.16146 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,437.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,439.52084 h 0.31771 l 0.16146,-0.16146 0.15625,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,439.52084 h -0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path647"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,438.88021 v 0.31771 l 0.15625,0.16146 0.16146,0.16146 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path648"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,438.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path649"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,437.28125 -0.16146,0.15625 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path650"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,437.1198 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path651"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,437.59896 -0.16146,-0.16146 -0.16146,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path652"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,437.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path653"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,439.19792 0.16146,-0.15625 0.16146,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path654"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,439.19792 h -0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path655"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,438.88021 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path656"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,438.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,436.95834 h -0.31771 l -0.32292,0.32291 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,436.95834 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,437.59896 v -0.31771 l -0.15625,-0.16145 -0.16146,-0.16146 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path660"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,437.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path661"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,439.52084 h 0.32291 l 0.16146,-0.16146 0.15625,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,439.52084 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,438.88021 v 0.31771 l 0.32292,0.32292 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,438.88021 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,437.28125 -0.16146,0.15625 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,437.1198 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,437.59896 -0.16146,-0.16146 -0.16145,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,437.59896 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,439.19792 0.16145,-0.15625 0.16146,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path670"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,439.19792 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path671"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,438.88021 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path672"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,438.88021 v -1.28125 m 3.19792,84 -4.64063,-0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path673"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.71875,518.07813 0.32292,1.28125 0.3177,0.47917 0.64063,0.47916 0.47917,0.16146 0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,518.07813 V 436.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path675"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.11979,433.59896 -0.64062,0.16146 -0.47917,0.16146 -0.64063,0.47917 -0.3177,0.47916 -0.32292,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path676"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,-0.00249667 4.640422,-0.96083 M 4.95813,79.518337 H 4.640422 M 4.95813,7.679795 H 4.640422 m 0,80.479167 V -0.96083 M 4.95813,79.518337 V 7.679795 m -81.598958,2.401042 h 2.083333 m -0.802083,2.557291 h 0.802083",
    transform: "matrix(0.75,0,0,0.75,414.84,325.08)",
    id: "path677"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00210067 -0.161052,-0.482274 -0.32251,-0.961441 l -0.479167,-0.15625 -0.479166,-0.161458 -0.479167,0.161458 -0.479167,0.15625 -0.161458,0.479167 -0.161458,0.48437467",
    transform: "matrix(0.75,0,0,0.75,358.32001,333.59999)",
    id: "path678"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00124567 0.159363,0.477921 0.320821,0.962296 0.799988,1.118546 1.279155,1.280004 1.758321,1.118546 2.237488,0.962296 2.398946,0.477921 2.560405,-0.00124567",
    transform: "matrix(0.75,0,0,0.75,356.40001,383.04)",
    id: "path679"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.00210067 V 46.241684 m 0,3.677083 v 9.28125 m 0,3.682292 v 3.036458 M 2.560405,0.00210067 V 46.241684 m 0,3.677083 v 9.28125 m 0,3.682292 v 3.036458 m 1.28125,10.880209 4.317708,-8.161459 m 1.921875,-3.359375 7.677083,-13.916666 m 1.760417,-3.520834 7.682292,-13.921875 m 1.916666,-3.359375 7.520834,-13.921875 m 1.921875,-3.515625 7.520833,-13.921875",
    transform: "matrix(0.75,0,0,0.75,356.40001,333.59999)",
    id: "path680"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,440.64063 4.48437,-8.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path681"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-8.39e-4 4.319366,8.160619 m 1.921875,3.359375 7.677083,13.921875 m 1.760417,3.515625 7.682292,13.921875 m 1.916666,3.359375 7.520834,13.921875 m 1.921875,3.520834 7.520833,13.916666",
    transform: "matrix(0.75,0,0,0.75,359.28001,324.36)",
    id: "path682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,513.4375 4.48437,8.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path683"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 479.04167,610.71875 v -89.11979 h 78.71875 v 89.11979 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 527.68229,521.59896 v 89.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,5.33333e-6 -0.320415,0.317714 -0.638123,5.33333e-6 -0.799581,0.317714 -1.122498,5.33333e-6 -1.278748,0.317714 -1.601665,5.33333e-6 -1.757915,0.317714 -2.080831,5.33333e-6 -2.24229,0.317714 -2.559998,5.33333e-6 -2.721456,0.317714 -3.039165,5.33333e-6 -3.200623,0.317714 -3.518331,5.33333e-6 -3.67979,0.317714",
    transform: "matrix(0.75,0,0,0.75,358.92,435)",
    id: "path686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.002502,-0.00148 -0.322917,-0.15625 -0.317708,0.15625 -0.161458,-0.15625 -0.322917,0.15625 -0.15625,-0.15625 -0.322917,0.15625 -0.15625,-0.15625 -0.322916,0.15625 -0.161459,-0.15625 -0.317708,0.15625 -0.161458,-0.15625 -0.317709,0.15625 -0.161458,-0.15625 -0.317708,0.15625 -0.161459,-0.15625",
    transform: "matrix(0.75,0,0,0.75,358.92,437.88002)",
    id: "path687"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.002304 V -3.362279 M 0.479573,0.002304 V -3.362279 M -0.47876,0.002304 V -3.362279 M -0.957927,0.002304 V -3.362279 M 0.161865,-3.679988 V 0.158554 M -0.32251,-3.679988 v 3.838542 m -0.479167,-3.838542 v 3.838542 m -0.479166,-3.838542 v 3.838542 m -0.161459,-0.15625 v -3.364583 m -0.479166,3.364583 v -3.364583 m -0.479167,3.364583 v -3.364583 m -0.479167,0 V 0.002304 M -1.76001,-3.679988 V 0.158554 M -2.239177,-3.679988 V 0.158554 M -2.718343,-3.679988 V 0.158554 M 0.80249,-3.679988 v 3.838542",
    transform: "matrix(0.75,0,0,0.75,358.32001,437.75999)",
    id: "path688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00168333 -0.320415,0.321233 -0.638123,-0.00168333 -0.799581,0.321233 -1.122498,-0.00168333 -1.278748,0.321233 -1.601665,-0.00168333 -1.757915,0.321233 -2.080831,-0.00168333 -2.24229,0.321233 -2.559998,-0.00168333 -2.721456,0.321233 -3.039165,-0.00168333 -3.200623,0.321233 -3.518331,-0.00168333 -3.67979,0.321233",
    transform: "matrix(0.75,0,0,0.75,358.92,444.72001)",
    id: "path689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00168333 -0.320415,-0.319392 -0.638123,-0.00168333 -0.799581,-0.319392 -1.122498,-0.00168333 -1.278748,-0.319392 -1.601665,-0.00168333 -1.757915,-0.319392 -2.080831,-0.00168333 -2.24229,-0.319392 -2.559998,-0.00168333 -2.721456,-0.319392 -3.039165,-0.00168333 -3.200623,-0.319392 -3.518331,-0.00168333 -3.67979,-0.319392",
    transform: "matrix(0.75,0,0,0.75,358.92,447.72001)",
    id: "path690"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,6.15333e-4 V -3.35876 M 0.479573,6.15333e-4 V -3.35876 M -0.47876,6.15333e-4 V -3.35876 M -0.957927,6.15333e-4 V -3.35876 m 1.119792,-0.322916 v 4 m -0.484375,-4 v 4 m -0.479167,-4 v 4 m -0.479166,-4 v 4 M -1.442302,6.15333e-4 V -3.35876 M -1.921468,6.15333e-4 V -3.35876 M -2.400635,6.15333e-4 V -3.35876 m -0.479167,0 V 6.15333e-4 M -1.76001,-3.681676 v 4 m -0.479167,-4 v 4 m -0.479166,-4 v 4 m 3.520833,-4 v 4 m 78.557292,-27.036459 v 37.4375",
    transform: "matrix(0.75,0,0,0.75,358.32001,447.48001)",
    id: "path691"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,608 h 0.32291 l 0.31771,-0.3177 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path692"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.31771,608 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path693"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,607.35938 v 0.32292 l 0.16146,0.15625 L 551.68229,608 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path694"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 551.19792,607.35938 V 524.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path695"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,524.31771 h -0.31771 l -0.32292,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path696"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,524.16146 h 4.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,524.95834 v -0.31771 l -0.15625,-0.16146 -0.16146,-0.16146 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path698"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.11979,524.95834 v 37.28125 m 0.47917,6.23958 v 39.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path699"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,608.31771 h 0.31771 l 0.16146,-0.15625 L 557.4375,608 v -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path700"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,608.47917 h -5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path701"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.88021,607.6823 V 608 l 0.31771,0.31771 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,607.6823 V 524.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,524 h -0.32291 l -0.15625,0.16146 -0.16146,0.15625 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,523.83855 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path705"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.4375,524.64063 v -0.32292 L 557.11979,524 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path706"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,6.15333e-4 V 39.198532 M -7.037476,-3.041051 V 86.07874 M -10.240601,-3.041051 V 86.07874 M 0.160441,57.761032 H -7.037476 M -2.558309,78.07874 V 63.042282",
    transform: "matrix(0.75,0,0,0.75,418.19998,393.48001)",
    id: "path707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,589.1198 -0.32291,-0.95834 -0.47917,-0.32291 -0.47917,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path708"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,589.1198 v 12.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path709"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,602.71875 0.47917,-0.15625 0.47917,-0.32291 0.32291,-0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path710"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,602.07813 v 0.16146 l 0.16146,0.32291 0.15625,0.15625 h 0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path711"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 554.71875,602.07813 V 588.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path712"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,587.6823 h -0.16145 l -0.15625,0.15625 -0.16146,0.32291 v 0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path713"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-8.08e-4 -0.479777,0.16065 -1.120402,0.639817 -1.43811,1.4419 l -0.484375,0.958334 -0.15625,1.28125 -0.161458,1.276041 v 1.28125 l 0.161458,1.28125 0.15625,1.28125 0.484375,0.958334 0.317708,0.802083 0.640625,0.479167 0.479167,0.161458 0.479167,-0.161458 0.640625,-0.479167 0.322916,-0.802083 0.479167,-0.958334 0.15625,-1.28125 0.161458,-1.28125 V 4.957525 L 2.077515,3.681484 1.921265,2.400234 1.442098,1.4419 1.119182,0.639817 0.478557,0.16065 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.51999,420.35998)",
    id: "path714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.13333e-4,0.00122633 -0.478353,0.157476 -0.95752,0.641851 -1.280437,1.438726 -1.598145,2.402268 -1.921062,3.52206 V 6.079351 L -1.598145,7.199143 -1.280437,8.157476 -0.95752,8.95956 -0.478353,9.438726 8.13333e-4,9.600185 0.47998,9.438726 0.959147,8.95956 1.282063,8.157476 1.599772,7.199143 1.91748,6.079351 V 3.52206 L 1.599772,2.402268 1.282063,1.438726 0.959147,0.641851 0.47998,0.157476 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.64001,420.96002)",
    id: "path715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,6.15333e-4 -0.478963,-0.160843 -0.95813,0.162074 -1.442505,0.79749 l -0.479167,0.802084 -0.15625,1.119791 -0.322916,1.28125 v 2.880209 l 0.322916,1.28125 0.15625,1.119791 0.479167,0.796875 0.484375,0.640625 0.479167,0.322917 0.479166333,-0.161458",
    transform: "matrix(0.75,0,0,0.75,416.16,420.48001)",
    id: "path716"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00101767,-0.00229333 -0.478149,-0.63771 l -0.322917,-0.322917 -0.479166,-0.161458 -0.317709,0.322917 -0.484375,0.479166 -0.317708,0.802084 -0.317708,1.119791 -0.161459,1.276042 -0.161458,1.442708 v 2.880209 l 0.161458,1.4375 0.161459,1.28125 0.317708,1.119791 0.317708,0.802084 0.484375,0.479166 0.317709,0.317709 0.479166,-0.15625 0.322917,-0.322917 0.47916667,-0.640625",
    transform: "matrix(0.75,0,0,0.75,415.80002,420.24)",
    id: "path717"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,571.83855 h 0.79687 m -0.79687,-11.52084 h 0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path718"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,546.07813 v -9.27604 h 1.27604 v 9.27604 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path719"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,551.19792 v 0.32292 l 0.31771,0.31771 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path720"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.64062,551.83855 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path721"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,551.83855 h 0.31771 l 0.16146,-0.15625 0.16145,-0.16146 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.64062,551.19792 V 531.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,531.6823 v -0.32292 l -0.16145,-0.16146 -0.16146,-0.15625 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,531.04167 h -3.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.64062,531.04167 h -0.32291 L 552,531.35938 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path726"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,531.6823 v 19.51562",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,551.83855 v 0.32291 l 0.16146,0.15625 0.15625,0.16146 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path728"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.16146,552.64063 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path729"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,552.47917 h 0.31771 l 0.16146,-0.16146 0.16145,-0.15625 v -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path730"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.80208,551.83855 V 531.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path731"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,531.19792 v -0.31771 l -0.16145,-0.16146 -0.16146,-0.15625 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path732"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,530.40105 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,530.5625 h -0.32292 l -0.31771,0.31771 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,531.19792 v 20.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path735"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-6.04667e-4 H 0.15916 V 0.322312 H -0.00229867 V 0.64002 H 0.320618 L 0.482076,0.322312 V -0.162063 L 0.15916,-0.318313 H -0.00229867 L 0.15916,-6.04667e-4 V 0.322312 H -0.00229867 V 0.160854 H 0.15916 v -0.479167 l -0.317709,0.15625 -0.161458,0.322917 0.161458,0.317708 L -0.00229867,0.64002 -0.158549,0.478562 -0.00229867,0.160854 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,449.51999)",
    id: "path736"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,2.08667e-4 H 0.15916 V 0.317917 H -0.00229867 V 0.640834 H 0.320618 L 0.482076,0.317917 V -0.16125 L 0.15916,-0.3175 H -0.00229867 L 0.15916,-0.16125 V 0.317917 H -0.00229867 V 2.08667e-4 H 0.15916 V -0.3175 h -0.317709 l -0.161458,0.479167 0.161458,0.317708 0.15625033,0.161459 H 0.15916 -0.00229867 L -0.158549,0.479375 -0.00229867,0.161667 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,446.16)",
    id: "path737"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,592 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path738"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,591.6823 h 0.64062 v 0.47916 l -0.48437,0.31771 h 0.48437 v 0.32292 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path739"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.16146,592.31771 552.47917,592",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path740"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,598.23959 0.64062,0.16146 v 0.47916 l -0.64062,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,597.92188 0.64062,-0.16146 v 0.31771 l -0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,596.16146 0.64062,0.31771 v 0.32292 l -0.64062,0.31771 h 0.64062 v 0.3177 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,596.80209 0.31771,-0.16146 -0.31771,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,595.83855 h 0.64062 v 0.32291 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path745"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,4.12e-4 -0.160848,-0.161046 H -0.478557 V -0.478755 H 6.1e-4 l 0.161458,0.15625 V 0.31812 L 6.1e-4,0.479579 H -0.478557 V 0.16187 h 0.317709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,445.32)",
    id: "path746"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,2.08667e-4 -0.160848,-0.16125 H -0.478557 V 2.08667e-4 h 0.317709 V -0.478958 L 0.162068,-0.3175 V 0.161667 L 6.1e-4,0.317917 -0.160848,0.479375 -0.478557,0.317917 -0.640015,2.08667e-4 -0.478557,-0.478958 h 0.317709 -0.161459 v 0.317708 h 0.161459 -0.161459 V 2.08667e-4 L -0.160848,0.161667 V 2.08667e-4 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,443.16)",
    id: "path747"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,0.00250733 V -0.638118 m 0,-0.484375 v -0.635416 m 0,-0.322917 v -0.640625 m 0,-3.036458 v -0.484375 m 0,-0.317709 v -0.317708",
    transform: "matrix(0.75,0,0,0.75,414.11998,448.91999)",
    id: "path748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,419.64062 0.24218,-2.8789 v 2.8789 z m 0,0",
    id: "path749"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,419.64062 v -2.8789 h 0.24218 z m 0,0",
    id: "path750"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,432.35937 0.24218,-2.75781 v 2.75781 z m 0,0",
    id: "path751"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,432.35937 v -2.75781 h 0.24218 z m 0,0",
    id: "path752"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,418.67969 0.23828,-2.75782 v 2.75782 z m 0,0",
    id: "path753"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,418.67969 v -2.75782 h 0.23828 z m 0,0",
    id: "path754"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,433.32031 0.23828,-2.8789 v 2.8789 z m 0,0",
    id: "path755"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,433.32031 v -2.8789 h 0.23828 z m 0,0",
    id: "path756"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,418.44141 0.23828,-2.88282 v 2.88282 z m 0,0",
    id: "path757"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,418.44141 v -2.88282 h 0.23828 z m 0,0",
    id: "path758"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,433.67969 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path759"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,433.67969 v -2.87891 h 0.23828 z m 0,0",
    id: "path760"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,418.55859 0.23828,-2.75781 v 2.75781 z m 0,0",
    id: "path761"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,418.55859 v -2.75781 h 0.23828 z m 0,0",
    id: "path762"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,433.44141 0.23828,-2.88282 v 2.88282 z m 0,0",
    id: "path763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,433.44141 v -2.88282 h 0.23828 z m 0,0",
    id: "path764"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,419.03906 0.12109,-2.8789 v 2.8789 z m 0,0",
    id: "path765"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,419.03906 v -2.8789 h 0.12109 z m 0,0",
    id: "path766"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,433.07812 0.12109,-2.8789 v 2.8789 z m 0,0",
    id: "path767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,433.07812 v -2.8789 h 0.12109 z m 0,0",
    id: "path768"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,420.23828 0.11719,-2.87891 v 2.87891 z m 0,0",
    id: "path769"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,420.23828 v -2.87891 h 0.11719 z m 0,0",
    id: "path770"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,431.76172 0.11719,-2.88281 v 2.88281 z m 0,0",
    id: "path771"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,431.76172 v -2.88281 h 0.11719 z m 0,0",
    id: "path772"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,572.80209 v 3.67708 h 0.32292 v -3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,573.92188 v 3.83854 h 0.31771 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,574.40105 v 3.83854 h 0.31771 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path775"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,574.07813 v 3.84375 h 0.31771 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path776"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,573.59896 v 3.83854 h 0.16146 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,571.83855 v 3.84375 h 0.15625 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path778"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,559.52084 v -3.83854 h 0.32292 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path779"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,558.23959 v -3.67709 h 0.31771 v 3.67709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path780"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,557.92188 v -3.84375 h 0.31771 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path781"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,558.07813 v -3.67708 h 0.31771 v 3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path782"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,558.71875 v -3.83854 h 0.16146 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,560.31771 v -3.83854 h 0.15625 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path784"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.31771,526.07813 H 552 l -0.16146,0.16146 -0.15625,0.16146 v 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.31771,526.07813 h 0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path786"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,526.71875 v -0.3177 l -0.15625,-0.16146 -0.16146,-0.16146 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 553.4375,526.71875 V 528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path788"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,528.64063 h 0.31771 l 0.16146,-0.16146 0.15625,-0.16146 V 528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path789"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,528.64063 h -0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path790"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,528 v 0.31771 l 0.15625,0.16146 0.16146,0.16146 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path791"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,528 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path792"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,526.40105 -0.31771,0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,526.23959 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,526.71875 -0.16146,-0.15625 -0.16146,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 553.28125,526.71875 V 528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path796"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,528.31771 0.16146,-0.15625 L 553.28125,528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path797"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,528.31771 h -0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path798"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,528 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path799"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,528 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,526.07813 h -0.31771 l -0.32292,0.32292 v 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,526.07813 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path802"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,526.71875 v -0.3177 l -0.15625,-0.16146 -0.16146,-0.16146 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path803"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.95833,526.71875 V 528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path804"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,528.64063 h 0.32291 l 0.16146,-0.16146 0.15625,-0.16146 V 528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,528.64063 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,528 v 0.31771 l 0.32292,0.32292 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path807"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,528 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path808"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,526.40105 -0.31771,0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path809"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,526.23959 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path810"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,526.71875 -0.16146,-0.15625 -0.16145,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path811"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.80208,526.71875 V 528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,528.31771 0.16145,-0.15625 L 556.80208,528",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,528.31771 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,528 0.15625,0.16146 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path815"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,528 v -1.28125 m 3.19792,84 -4.64063,-0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path816"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.71875,607.04167 0.16146,0.64063 0.16146,0.63541 0.3177,0.48438 0.64063,0.47916 0.47917,0.15625 0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path817"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,607.04167 V 525.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path818"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.11979,522.5625 -0.64062,0.15625 -0.47917,0.16146 -0.64063,0.47917 -0.3177,0.47917 -0.32292,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path819"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.00250733 4.640422,-0.961034 M 4.95813,79.518132 H 4.640422 M 4.95813,7.679591 H 4.640422 m 0,80.479166 V -0.961034 M 4.95813,79.518132 V 7.679591 m -81.598958,2.401041 h 2.083333 m -0.802083,2.557292 h 0.802083",
    transform: "matrix(0.75,0,0,0.75,414.84,391.91999)",
    id: "path820"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00189733 -0.161052,-0.482478 -0.32251,-0.961644 l -0.479167,-0.15625 -0.479166,-0.161459 -0.479167,0.161459 -0.479167,0.15625 -0.161458,0.479166 -0.161458,0.48437533",
    transform: "matrix(0.75,0,0,0.75,358.32001,400.43998)",
    id: "path821"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.002304 0.320821,0.960637 0.799988,1.122096 1.279155,1.278346 1.758321,1.122096 2.237488,0.960637 2.560405,0.002304",
    transform: "matrix(0.75,0,0,0.75,356.40001,449.75999)",
    id: "path822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.00189733 V 46.241481 m 0,3.520833 v 9.4375 m 0,3.682292 v 2.880208 M 2.560405,0.00189733 V 46.241481 m 0,3.520833 v 9.4375 m 0,3.682292 v 2.880208 m 1.28125,11.036458 4.317708,-8.15625 m 1.921875,-3.520833 7.677083,-13.760417 m 1.760417,-3.520833 7.682292,-13.921875 m 1.916666,-3.520833 7.520834,-13.755209 m 1.921875,-3.520833 7.520833,-13.921875",
    transform: "matrix(0.75,0,0,0.75,356.40001,400.43998)",
    id: "path823"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,529.59896 4.48437,-8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-0.00101233 4.319366,7.998988 m 1.921875,3.520833 7.677083,13.921875 m 1.760417,3.520833 7.682292,13.755209 m 1.916666,3.520833 7.520834,13.921875 m 1.921875,3.520833 7.520833,13.760417",
    transform: "matrix(0.75,0,0,0.75,359.28001,391.19998)",
    id: "path825"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,602.5625 4.48437,8.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path826"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 479.04167,699.6823 v -88.96355 h 78.71875 v 88.96355 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path827"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 527.68229,610.71875 V 699.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-1.98e-4 -0.320415,0.16126 -0.638123,-1.98e-4 -0.799581,0.16126 -1.122498,-1.98e-4 -1.278748,0.16126 -1.601665,-1.98e-4 -1.757915,0.16126 -2.080831,-1.98e-4 -2.24229,0.16126 -2.559998,-1.98e-4 -2.721456,0.16126 -3.039165,-1.98e-4 -3.200623,0.16126 -3.518331,-1.98e-4 -3.67979,0.16126",
    transform: "matrix(0.75,0,0,0.75,358.92,501.83999)",
    id: "path829"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00168333 -0.320415,-0.157933 -0.638123,-0.00168333 -0.799581,-0.157933 -1.122498,-0.00168333 -1.278748,-0.157933 -1.601665,-0.00168333 -1.757915,-0.157933 -2.080831,-0.00168333 -2.24229,-0.157933 -2.559998,-0.00168333 -2.721456,-0.157933 -3.039165,-0.00168333 -3.200623,-0.157933 -3.518331,-0.00168333 -3.67979,-0.157933",
    transform: "matrix(0.75,0,0,0.75,358.92,504.72001)",
    id: "path830"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00210067 V -3.518733 M 0.479573,0.00210067 V -3.518733 M -0.47876,0.00210067 V -3.518733 M -0.957927,0.00210067 V -3.518733 M 0.161865,-3.680191 V 0.158351 M -0.32251,-3.680191 V 0.158351 M -0.801677,-3.680191 V 0.158351 M -1.280843,-3.680191 V 0.158351 M -1.442302,0.00210067 V -3.518733 M -1.921468,0.00210067 V -3.518733 M -2.400635,0.00210067 V -3.518733 m -0.479167,0 V 0.00210067 M -1.76001,-3.680191 V 0.158351 M -2.239177,-3.680191 V 0.158351 M -2.718343,-3.680191 V 0.158351 M 0.80249,-3.680191 v 3.838542",
    transform: "matrix(0.75,0,0,0.75,358.32001,504.59999)",
    id: "path831"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00188667 -0.320415,0.32103 -0.638123,-0.00188667 -0.799581,0.32103 -1.122498,-0.00188667 -1.278748,0.32103 -1.601665,-0.00188667 -1.757915,0.32103 -2.080831,-0.00188667 -2.24229,0.32103 -2.559998,-0.00188667 -2.721456,0.32103 -3.039165,-0.00188667 -3.200623,0.32103 -3.518331,-0.00188667 -3.67979,0.32103",
    transform: "matrix(0.75,0,0,0.75,358.92,511.56001)",
    id: "path832"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00189733 -0.320415,-0.159561 -0.638123,0.00189733 -0.799581,-0.159561 -1.122498,0.00189733 -1.278748,-0.159561 -1.601665,0.00189733 -1.757915,-0.159561 -2.080831,0.00189733 -2.24229,-0.159561 -2.559998,0.00189733 -2.721456,-0.159561 -3.039165,0.00189733 -3.200623,-0.159561 -3.518331,0.00189733 -3.67979,-0.159561",
    transform: "matrix(0.75,0,0,0.75,358.92,514.43998)",
    id: "path833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,4.12e-4 V -3.358963 M 0.479573,4.12e-4 V -3.358963 M -0.47876,4.12e-4 V -3.358963 M -0.957927,4.12e-4 V -3.358963 M 0.161865,-3.68188 V 0.16187 M -0.32251,-3.68188 V 0.16187 M -0.801677,-3.68188 V 0.16187 M -1.280843,-3.68188 V 0.16187 M -1.442302,4.12e-4 V -3.358963 M -1.921468,4.12e-4 V -3.358963 M -2.400635,4.12e-4 v -3.359375 m -0.479167,0 V 4.12e-4 M -1.76001,-3.68188 V 0.16187 M -2.239177,-3.68188 V 0.16187 M -2.718343,-3.68188 V 0.16187 M 0.80249,-3.68188 v 3.84375 m 78.557292,-26.880208 v 37.276042",
    transform: "matrix(0.75,0,0,0.75,358.32001,514.32)",
    id: "path834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,696.95834 h 0.32291 l 0.16146,-0.15625 0.15625,-0.16146 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.31771,697.1198 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path836"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,696.31771 v 0.32292 l 0.16146,0.16146 0.16146,0.15625 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 551.19792,696.31771 V 614.07813",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,613.4375 h -0.31771 l -0.32292,0.32292 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path839"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,613.28125 h 4.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path840"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,614.07813 v -0.31771 l -0.15625,-0.16146 -0.16146,-0.16146 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path841"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.11979,614.07813 v 37.28125 m 0.47917,6.23958 v 39.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path842"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,697.4375 h 0.31771 l 0.16146,-0.15625 0.15625,-0.16145 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path843"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,697.59896 h -5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path844"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.88021,696.80209 v 0.31771 l 0.31771,0.3177 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path845"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,696.80209 V 613.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path846"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,612.95834 h -0.32291 l -0.15625,0.16146 -0.16146,0.16145 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path847"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,612.80209 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path848"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.4375,613.59896 v -0.31771 l -0.15625,-0.16145 -0.16146,-0.16146 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path849"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,-0.00101233 V 39.358363 M -7.037476,-2.881221 V 86.082321 M -10.240601,-2.881221 V 86.082321 M 0.160441,57.759404 h -7.197917 m 4.479167,20.479167 V 63.202113",
    transform: "matrix(0.75,0,0,0.75,418.19998,460.19998)",
    id: "path850"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,678.23959 -0.32291,-0.95834 -0.47917,-0.32291 -0.47917,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path851"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,678.23959 v 12.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path852"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,691.83855 0.47917,-0.15625 0.47917,-0.32292 0.32291,-0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,691.19792 v 0.16146 l 0.16146,0.32292 0.15625,0.15625 h 0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path854"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 554.71875,691.19792 V 677.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,676.80209 h -0.16145 l -0.15625,0.15625 -0.16146,0.32291 v 0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path856"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00101233 -0.479777,0.160446 -1.120402,0.639613 -1.43811,1.441696 l -0.484375,0.958333 -0.15625,1.28125 -0.161458,1.28125 v 1.276042 l 0.161458,1.28125 0.15625,1.28125 0.484375,0.958333 0.317708,0.802084 0.640625,0.479166 0.479167,0.161459 0.479167,-0.161459 0.640625,-0.479166 0.322916,-0.802084 0.479167,-0.958333 0.15625,-1.28125 0.161458,-1.28125 V 4.962529 L 2.077515,3.681279 1.921265,2.400029 1.442098,1.441696 1.119182,0.639613 0.478557,0.160446 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.51999,487.19998)",
    id: "path857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.13333e-4,0.001023 -0.478353,0.162481 -0.95752,0.641648 -1.280437,1.438523 -1.598145,2.402065 -1.921062,3.521856 V 6.079148 L -1.598145,7.19894 -1.280437,8.162481 -0.95752,8.959356 -0.478353,9.438523 8.13333e-4,9.599981 0.47998,9.438523 0.959147,8.959356 1.282063,8.162481 1.599772,7.19894 1.91748,6.079148 V 3.521856 L 1.599772,2.402065 1.282063,1.438523 0.959147,0.641648 0.47998,0.162481 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.64001,487.80001)",
    id: "path858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,4.12e-4 -0.478963,-0.161046 -0.95813,0.16187 -1.442505,0.802495 -1.921672,1.59937 -2.077922,2.719162 -2.400838,4.000412 V 6.88062 l 0.322916,1.28125 0.15625,1.119792 0.479167,0.796875 0.484375,0.640625 0.479167,0.322917 0.479166333,-0.161459",
    transform: "matrix(0.75,0,0,0.75,416.16,487.32)",
    id: "path859"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00101767,-0.00249667 -0.478149,-0.637913 -0.801066,-0.96083 -1.280232,-1.122288 -1.597941,-0.799372 -2.082316,-0.320205 -2.400024,0.481878 -2.717732,1.60167 -2.879191,2.877712 -3.040649,4.32042 v 2.880208 l 0.161458,1.4375 0.161459,1.28125 0.317708,1.119792 0.317708,0.802083 0.484375,0.479167 0.317709,0.317708 0.479166,-0.15625 0.322917,-0.322916 0.47916667,-0.640625",
    transform: "matrix(0.75,0,0,0.75,415.80002,487.08)",
    id: "path860"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,660.95834 h 0.79687 M 554.5625,649.4375 h 0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path861"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,635.19792 v -9.27604 h 1.27604 v 9.27604 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,640.31771 v 0.32292 l 0.31771,0.31771 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.64062,640.95834 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path864"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,640.95834 h 0.31771 l 0.16146,-0.15625 0.16145,-0.16146 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path865"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.64062,640.31771 V 620.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,620.80209 v -0.32292 l -0.16145,-0.16146 -0.16146,-0.15625 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,620.16146 h -3.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.64062,620.16146 h -0.32291 L 552,620.47917 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path869"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,620.80209 v 19.51562",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path870"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,640.80209 v 0.31771 l 0.31771,0.3177 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path871"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.16146,641.59896 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,641.4375 h 0.31771 l 0.16146,-0.15625 0.16145,-0.16145 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.80208,640.80209 V 620.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path874"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.64062,620.31771 V 620 l -0.16145,-0.16145 -0.16146,-0.15625 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,619.52084 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path876"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,619.6823 h -0.32292 L 551.52083,620 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path877"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,620.31771 v 20.48438",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path878"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-8.08e-4 H 0.15916 V 0.322109 H -0.00229867 V 0.639817 H 0.320618 L 0.482076,0.322109 V -0.162266 L 0.15916,-0.318516 H -0.00229867 L 0.15916,-0.162266 V 0.322109 H -0.00229867 V 0.16065 L 0.15916,-8.08e-4 V -0.318516 H -0.158549 L -0.320007,0.16065 -0.158549,0.478359 -0.00229867,0.639817 -0.158549,0.478359 -0.00229867,0.16065 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,516.35998)",
    id: "path879"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,5.33333e-6 H 0.15916 V 0.161464 l -0.16145867,0.15625 V 0.64063 H 0.320618 L 0.482076,0.161464 V -0.161453 L 0.15916,-0.317703 H -0.00229867 L 0.15916,-0.161453 V 0.317714 H -0.00229867 V 5.33333e-6 H 0.15916 V -0.317703 H -0.158549 L -0.320007,5.33333e-6 -0.158549,0.479172 -0.00229867,0.64063 H 0.15916 -0.00229867 L -0.158549,0.317714 -0.00229867,0.161464 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,513)",
    id: "path880"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,681.1198 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path881"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,680.80209 h 0.64062 v 0.47916 l -0.48437,0.31771 h 0.48437 v 0.32292 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path882"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,681.4375 0.31771,-0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,687.35938 0.64062,0.16146 V 688 l -0.64062,-0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path884"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,687.04167 0.64062,-0.32292 v 0.47917 l -0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path885"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,685.28125 0.64062,0.31771 v 0.32292 l -0.64062,0.15625 0.64062,0.16146 v 0.32291 l -0.64062,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path886"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,685.92188 0.31771,-0.16146 -0.31771,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path887"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,684.95834 h 0.64062 v 0.32291 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path888"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,2.08667e-4 -0.160848,-0.16125 H -0.478557 V -0.478958 H 6.1e-4 L 0.162068,-0.3175 V 0.161667 L 6.1e-4,0.317917 -0.160848,0.479375 H -0.478557 V 2.08667e-4 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,512.16)",
    id: "path889"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,-0.00148 h -0.161458 v -0.15625 l -0.317709,0.15625 h 0.317709 v -0.479167 l 0.322916,0.161459 V 0.321437 L 6.1e-4,0.477687 h -0.479167 l -0.161458,-0.317709 0.161458,-0.479166 0.317709,-0.161459 h -0.161459 v 0.322917 l 0.161459,0.15625 h -0.161459 v 0.161458 h 0.161459 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,509.88002)",
    id: "path890"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00148533,0.002304 v -0.640625 m 0,-0.640625 v -0.479167 m 0,-0.322916 v -0.640625 m 0,-3.036459 v -0.484375 m 0,-0.317708 v -0.317708",
    transform: "matrix(0.75,0,0,0.75,414.11998,515.75999)",
    id: "path891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,486.48047 0.24218,-2.87891 v 2.87891 z m 0,0",
    id: "path892"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,486.48047 v -2.87891 h 0.24218 z m 0,0",
    id: "path893"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,499.19922 0.24218,-2.87891 v 2.87891 z m 0,0",
    id: "path894"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,499.19922 v -2.87891 h 0.24218 z m 0,0",
    id: "path895"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,485.51953 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,485.51953 v -2.87891 h 0.23828 z m 0,0",
    id: "path897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,500.16016 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path898"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,500.16016 v -2.87891 h 0.23828 z m 0,0",
    id: "path899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,485.16016 0.23828,-2.76172 v 2.76172 z m 0,0",
    id: "path900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,485.16016 v -2.76172 h 0.23828 z m 0,0",
    id: "path901"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,500.39844 0.23828,-2.75782 v 2.75782 z m 0,0",
    id: "path902"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,500.39844 v -2.75782 h 0.23828 z m 0,0",
    id: "path903"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,485.39844 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path904"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,485.39844 v -2.87891 h 0.23828 z m 0,0",
    id: "path905"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,500.28125 0.23828,-2.88281 v 2.88281 z m 0,0",
    id: "path906"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,500.28125 v -2.88281 h 0.23828 z m 0,0",
    id: "path907"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 417,485.87891 417.12109,483 v 2.87891 z m 0,0",
    id: "path908"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 417,485.87891 V 483 h 0.12109 z m 0,0",
    id: "path909"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,499.80078 0.12109,-2.76172 v 2.76172 z m 0,0",
    id: "path910"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,499.80078 v -2.76172 h 0.12109 z m 0,0",
    id: "path911"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,487.07812 0.11719,-2.8789 v 2.8789 z m 0,0",
    id: "path912"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,487.07812 v -2.8789 h 0.11719 z m 0,0",
    id: "path913"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,498.60156 0.11719,-2.88281 v 2.88281 z m 0,0",
    id: "path914"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,498.60156 v -2.88281 h 0.11719 z m 0,0",
    id: "path915"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,661.76042 v 3.83854 h 0.32292 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,663.04167 v 3.83854 h 0.31771 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,663.52084 v 3.67708 h 0.31771 v -3.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path918"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,663.19792 v 3.84375 h 0.31771 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path919"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,662.71875 v 3.6823 h 0.16146 v -3.6823 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path920"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,660.95834 v 3.84375 h 0.15625 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path921"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,648.64063 v -3.83854 h 0.32292 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,647.35938 v -3.83854 h 0.31771 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path923"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,646.88021 v -3.68229 h 0.31771 v 3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path924"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,647.19792 v -3.83854 h 0.31771 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path925"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556,647.83855 V 644 h 0.16146 v 3.83855 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path926"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,649.4375 v -3.83854 h 0.15625 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path927"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.31771,615.04167 H 552 l -0.16146,0.15625 -0.15625,0.16146 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.31771,615.04167 h 0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path929"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,615.6823 v -0.32292 l -0.15625,-0.16146 -0.16146,-0.15625 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path930"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,615.6823 v 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path931"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,617.76042 h 0.31771 l 0.16146,-0.16146 0.15625,-0.16146 v -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path932"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,617.76042 h -0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,617.1198 v 0.3177 l 0.15625,0.16146 0.16146,0.16146 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,617.1198 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path935"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,615.35938 -0.16146,0.16146 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path936"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,615.35938 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,615.6823 -0.32292,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,615.6823 v 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path939"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,617.4375 0.16146,-0.15625 0.16146,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path940"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,617.4375 h -0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path941"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,617.1198 0.15625,0.16145 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path942"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,617.1198 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path943"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,615.04167 h -0.31771 l -0.16146,0.15625 -0.16146,0.16146 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,615.04167 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path945"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,615.6823 v -0.32292 l -0.15625,-0.16146 -0.16146,-0.15625 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path946"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,615.6823 v 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path947"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,617.76042 h 0.32291 l 0.16146,-0.16146 0.15625,-0.16146 v -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,617.76042 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path949"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,617.1198 v 0.3177 l 0.32292,0.32292 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,617.1198 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path951"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,615.35938 -0.16146,0.16146 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path952"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,615.35938 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,615.6823 -0.32291,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path954"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,615.6823 v 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path955"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,617.4375 0.16145,-0.15625 0.16146,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path956"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,617.4375 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,617.1198 0.15625,0.16145 0.16146,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path958"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,617.1198 v -1.4375 m 3.19792,84 -4.64063,-0.96355",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path959"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.71875,696.16146 0.16146,0.64063 0.16146,0.63541 0.3177,0.48438 0.64063,0.47917 0.47917,0.16145 0.64062,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path960"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,696.16146 V 614.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path961"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.11979,611.6823 -0.64062,0.15625 L 552,612 l -0.64063,0.47917 -0.3177,0.47917 -0.32292,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.002304 4.640422,-0.961238 M 4.95813,79.361679 H 4.640422 M 4.95813,7.679387 H 4.640422 m 0,80.322917 V -0.961238 M 4.95813,79.361679 V 7.679387 m -81.598958,2.401042 h 2.083333 m -0.802083,2.557292 h 0.802083",
    transform: "matrix(0.75,0,0,0.75,414.84,458.75999)",
    id: "path963"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.001694 -0.161052,-0.477473 -0.32251,-0.961848 l -0.479167,-0.15625 -0.479166,-0.161458 -0.479167,0.161458 -0.479167,0.15625 -0.161458,0.484375 -0.161458,0.479167",
    transform: "matrix(0.75,0,0,0.75,358.32001,467.27998)",
    id: "path964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.00210067 0.320821,0.960434 0.799988,1.121892 1.279155,1.278142 1.758321,1.121892 2.237488,0.960434 2.560405,0.00210067",
    transform: "matrix(0.75,0,0,0.75,356.40001,516.59999)",
    id: "path965"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.00209533,0.001694 v 46.239583 m 0,3.520834 v 9.4375 m 0,3.520833 v 3.041667 M 2.560405,0.001694 v 46.239583 m 0,3.520834 v 9.4375 m 0,3.520833 v 3.041667 m 1.28125,10.880208 4.317708,-8 m 1.921875,-3.520833 7.677083,-13.921875 m 1.760417,-3.359375 7.682292,-13.921875 m 1.916666,-3.520834 7.520834,-13.916666 m 1.921875,-3.359375 7.520833,-13.921875",
    transform: "matrix(0.75,0,0,0.75,356.40001,467.27998)",
    id: "path966"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,618.71875 4.48437,-8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-0.00121567 4.319366,7.998784 m 1.921875,3.520834 7.677083,13.921875 m 1.760417,3.359375 7.682292,13.916666 m 1.916666,3.520834 7.520834,13.921875 m 1.921875,3.359375 7.520833,13.921875",
    transform: "matrix(0.75,0,0,0.75,359.28001,458.03997)",
    id: "path968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,691.6823 4.48437,8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path969"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 479.04167,788.80209 V 699.6823 h 78.71875 v 89.11979 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path970"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 527.68229,699.6823 v 89.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path971"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-4.01333e-4 -0.320415,0.161057 -0.638123,-4.01333e-4 -0.799581,0.161057 -1.122498,-4.01333e-4 -1.278748,0.161057 -1.601665,-4.01333e-4 -1.757915,0.161057 -2.080831,-4.01333e-4 -2.24229,0.161057 -2.559998,-4.01333e-4 -2.721456,0.161057 -3.039165,-4.01333e-4 -3.200623,0.161057 -3.518331,-4.01333e-4 -3.67979,0.161057",
    transform: "matrix(0.75,0,0,0.75,358.92,568.67999)",
    id: "path972"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00188667 -0.320415,-0.319595 -0.638123,-0.00188667 -0.799581,-0.319595 -1.122498,-0.00188667 -1.278748,-0.319595 -1.601665,-0.00188667 -1.757915,-0.319595 -2.080831,-0.00188667 -2.24229,-0.319595 -2.559998,-0.00188667 -2.721456,-0.319595 -3.039165,-0.00188667 -3.200623,-0.319595 -3.518331,-0.00188667 -3.67979,-0.319595",
    transform: "matrix(0.75,0,0,0.75,358.92,571.56001)",
    id: "path973"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,4.12e-4 V -3.358963 M 0.479573,4.12e-4 V -3.358963 M -0.47876,4.12e-4 V -3.358963 M -0.957927,4.12e-4 V -3.358963 M 0.161865,-3.520421 V 0.31812 M -0.32251,-3.520421 V 0.31812 M -0.801677,-3.520421 V 0.31812 M -1.280843,-3.520421 V 0.31812 M -1.442302,4.12e-4 V -3.358963 M -1.921468,4.12e-4 V -3.358963 M -2.400635,4.12e-4 v -3.359375 m -0.479167,0 V 4.12e-4 M -1.76001,-3.520421 V 0.31812 M -2.239177,-3.520421 V 0.31812 M -2.718343,-3.520421 V 0.31812 M 0.80249,-3.520421 V 0.31812",
    transform: "matrix(0.75,0,0,0.75,358.32001,571.32)",
    id: "path974"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00209 -0.320415,0.159368 -0.638123,-0.00209 -0.799581,0.159368 -1.122498,-0.00209 -1.278748,0.159368 -1.601665,-0.00209 -1.757915,0.159368 -2.080831,-0.00209 -2.24229,0.159368 -2.559998,-0.00209 -2.721456,0.159368 -3.039165,-0.00209 -3.200623,0.159368 -3.518331,-0.00209 -3.67979,0.159368",
    transform: "matrix(0.75,0,0,0.75,358.92,578.4)",
    id: "path975"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.001694 -0.320415,-0.159764 -0.638123,0.001694 -0.799581,-0.159764 -1.122498,0.001694 -1.278748,-0.159764 -1.601665,0.001694 -1.757915,-0.159764 -2.080831,0.001694 -2.24229,-0.159764 -2.559998,0.001694 -2.721456,-0.159764 -3.039165,0.001694 -3.200623,-0.159764 -3.518331,0.001694 -3.67979,-0.159764",
    transform: "matrix(0.75,0,0,0.75,358.92,581.27998)",
    id: "path976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,2.08667e-4 V -3.520625 M 0.479573,2.08667e-4 V -3.520625 M -0.47876,2.08667e-4 V -3.520625 M -0.957927,2.08667e-4 V -3.520625 m 1.119792,-0.161458 v 3.84375 m -0.484375,-3.84375 v 3.84375 m -0.479167,-3.84375 v 3.84375 m -0.479166,-3.84375 v 3.84375 M -1.442302,2.08667e-4 V -3.520625 M -1.921468,2.08667e-4 V -3.520625 M -2.400635,2.08667e-4 V -3.520625 m -0.479167,0 V 2.08667e-4 M -1.76001,-3.682083 v 3.84375 m -0.479167,-3.84375 v 3.84375 m -0.479166,-3.84375 v 3.84375 m 3.520833,-3.84375 v 3.84375 M 79.359782,-26.718541 V 10.5575",
    transform: "matrix(0.75,0,0,0.75,358.32001,581.16)",
    id: "path977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,786.07813 h 0.32291 l 0.16146,-0.15625 0.15625,-0.16146 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path978"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.31771,786.23959 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path979"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,785.4375 v 0.32292 l 0.16146,0.16146 0.16146,0.15625 H 552",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path980"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 551.19792,785.4375 V 703.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,702.5625 h -0.31771 l -0.16146,0.15625 -0.16146,0.16146 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path982"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,702.40105 h 4.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path983"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,703.19792 v -0.31771 l -0.15625,-0.16146 -0.16146,-0.15625 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.11979,703.19792 v 37.28125 m 0.47917,6.08333 v 39.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,786.5625 h 0.31771 l 0.16146,-0.16145 0.15625,-0.16146 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path986"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,786.5625 h -5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.88021,785.92188 v 0.31771 l 0.16146,0.16146 0.15625,0.16145 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,785.92188 V 702.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,702.07813 h -0.32291 l -0.15625,0.16146 -0.16146,0.16146 v 0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path990"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,701.92188 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 557.4375,702.71875 v -0.3177 l -0.15625,-0.16146 -0.16146,-0.16146 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path992"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,-0.00121567 V 39.201909 M -7.037476,-3.037674 V 86.082118 M -10.240601,-3.037674 V 86.082118 M 0.160441,57.759201 h -7.197917 m 4.479167,20.322917 V 63.201909",
    transform: "matrix(0.75,0,0,0.75,418.19998,527.03997)",
    id: "path993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,767.35938 -0.32291,-0.95833 -0.47917,-0.32292 -0.47917,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,767.35938 v 12.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path995"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,780.95834 0.47917,-0.15625 0.47917,-0.32292 0.32291,-0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path996"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,780.31771 v 0.16146 l 0.16146,0.32292 0.15625,0.15625 h 0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path997"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 554.71875,780.31771 V 766.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 555.35937,765.92188 h -0.16145 l -0.15625,0.15625 -0.16146,0.32292 v 0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00121567 -0.479777,0.160243 -1.120402,0.639409 -1.43811,1.441493 l -0.484375,0.958333 -0.15625,1.28125 -0.161458,1.28125 v 1.276042 l 0.161458,1.28125 0.15625,1.28125 0.484375,0.958333 0.317708,0.802083 0.640625,0.479167 0.479167,0.161458 0.479167,-0.161458 0.640625,-0.479167 0.322916,-0.802083 0.479167,-0.958333 0.15625,-1.28125 0.161458,-1.28125 V 4.962326 L 2.077515,3.681076 1.921265,2.399826 1.442098,1.441493 1.119182,0.639409 0.478557,0.160243 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.51999,554.03997)",
    id: "path1000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.13333e-4,8.18667e-4 -0.478353,0.162277 -0.95752,0.641444 -1.280437,1.438319 -1.598145,2.40186 -1.921062,3.521652 v 2.557292 l 0.322917,1.119791 0.317708,0.963542 0.322917,0.796875 0.479167,0.479167 L 8.13333e-4,9.599777 0.47998,9.438319 0.959147,8.959152 1.282063,8.162277 1.599772,7.198735 1.91748,6.078944 V 3.521652 L 1.599772,2.40186 1.282063,1.438319 0.959147,0.641444 0.47998,0.162277 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,416.64001,554.64001)",
    id: "path1001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,2.08667e-4 -0.478963,-0.16125 -0.95813,0.161667 l -0.484375,0.640625 -0.479167,0.796875 -0.15625,1.119792 -0.322916,1.28125 v 2.880208 l 0.322916,1.28125 0.15625,1.119792 0.479167,0.796875 0.484375,0.640625 0.479167,0.322916 0.479166333,-0.161458",
    transform: "matrix(0.75,0,0,0.75,416.16,554.16)",
    id: "path1002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00101767,0.00250733 -0.478149,-0.638118 l -0.322917,-0.322916 -0.479166,-0.161459 -0.317709,0.322917 -0.484375,0.479167 -0.317708,0.802083 -0.317708,1.119792 -0.161459,1.276041 -0.161458,1.442709 v 2.880208 l 0.161458,1.4375 0.161459,1.28125 0.317708,1.119792 0.317708,0.802083 0.484375,0.479167 0.317709,0.317708 0.479166,-0.15625 0.322917,-0.322917 0.47916667,-0.640625",
    transform: "matrix(0.75,0,0,0.75,415.80002,553.91999)",
    id: "path1003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,750.07813 h 0.79687 M 554.5625,738.5625 h 0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,724.31771 v -9.27604 h 1.27604 v 9.27604 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552,729.4375 v 0.32292 l 0.31771,0.31771 h 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.64062,730.07813 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1007"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,730.07813 h 0.31771 l 0.16146,-0.15625 0.16145,-0.16146 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.64062,729.4375 V 709.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,709.92188 v -0.32292 l -0.16145,-0.16146 -0.16146,-0.15625 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1010"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,709.28125 h -3.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1011"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.64062,709.28125 h -0.32291 L 552,709.59896 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552,709.92188 V 729.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.52083,729.92188 v 0.31771 l 0.16146,0.16146 0.15625,0.16145 h 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.16146,730.71875 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,730.5625 h 0.31771 l 0.32291,-0.32291 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 556.80208,729.92188 V 709.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.64062,709.28125 v -0.32291 l -0.16145,-0.15625 -0.16146,-0.16146 H 556",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1018"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,708.64063 h -3.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1019"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,708.64063 h -0.32292 l -0.15625,0.16146 -0.16146,0.15625 v 0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1020"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.35937,709.28125 v 20.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00101233 H 0.15916 V 0.160446 L -0.00229867,0.321904 V 0.639613 H 0.320618 L 0.482076,0.160446 V -0.162471 L 0.15916,-0.318721 H -0.00229867 L 0.15916,-0.162471 V 0.321904 H -0.00229867 V -0.00101233 H 0.15916 V -0.318721 H -0.158549 L -0.320007,-0.00101233 -0.158549,0.478154 -0.00229867,0.639613 -0.158549,0.478154 -0.00229867,0.160446 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,583.19998)",
    id: "path1022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-1.98e-4 H 0.15916 V 0.16126 H -0.00229867 V 0.640427 H 0.15916 L 0.320618,0.478969 0.482076,0.16126 V -0.317906 L 0.15916,-0.479365 h -0.16145867 v 0.161459 L 0.15916,-0.161656 V 0.16126 H -0.00229867 V -1.98e-4 H 0.15916 v -0.317708 h -0.317709 l -0.161458,0.317708 0.161458,0.479167 0.15625033,0.161458 H 0.15916 L -0.00229867,0.478969 -0.158549,0.31751 -0.00229867,0.16126 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.24,579.83999)",
    id: "path1023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,770.23959 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,769.92188 h 0.64062 v 0.47917 l -0.48437,0.3177 h 0.48437 v 0.32292 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,770.5625 0.31771,-0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,776.47917 0.64062,0.16146 v 0.31771 l -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1027"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,776.16146 0.64062,-0.32291 v 0.47916 l -0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1028"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,774.40105 0.64062,0.3177 v 0.32292 l -0.64062,0.15625 h 0.64062 v 0.32292 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,775.04167 0.31771,-0.16146 -0.31771,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1030"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,774.07813 h 0.64062 v 0.32292 h -0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1031"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,-0.00148 H -0.160848 V -0.15773 H -0.478557 V -0.480647 H 6.1e-4 l 0.161458,0.161459 V 0.321437 L 6.1e-4,0.477687 H -0.478557 V 0.159978 h 0.317709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,578.88002)",
    id: "path1032"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,-0.00168333 -0.160848,-0.157933 h -0.317709 v 0.15624967 h 0.317709 V -0.48085 l 0.322916,0.161458 V 0.321233 L 6.1e-4,0.477483 h -0.161458 l -0.317709,-0.15625 -0.161458,-0.161458 0.161458,-0.479167 0.317709,-0.161458 h -0.161459 v 0.322917 h 0.161459 -0.161459 v 0.15624967 L -0.160848,0.159775 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,414.48001,576.72001)",
    id: "path1033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,0.00210067 V -0.638524 m 0,-0.640625 v -0.479167 m 0,-0.322917 v -0.640625 m 0,-3.036458 v -0.479167 m 0,-0.322916 v -0.317709",
    transform: "matrix(0.75,0,0,0.75,414.11998,582.59999)",
    id: "path1034"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,553.32031 0.24218,-2.8789 v 2.8789 z m 0,0",
    id: "path1035"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,553.32031 v -2.8789 h 0.24218 z m 0,0",
    id: "path1036"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,566.03906 0.24218,-2.8789 v 2.8789 z m 0,0",
    id: "path1037"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 413.87891,566.03906 v -2.8789 h 0.24218 z m 0,0",
    id: "path1038"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,552.35937 0.23828,-2.8789 v 2.8789 z m 0,0",
    id: "path1039"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,552.35937 v -2.8789 h 0.23828 z m 0,0",
    id: "path1040"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,566.87891 0.23828,-2.75782 v 2.75782 z m 0,0",
    id: "path1041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 414.60156,566.87891 v -2.75782 h 0.23828 z m 0,0",
    id: "path1042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,552 0.23828,-2.76172 V 552 Z m 0,0",
    id: "path1043"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,552 v -2.76172 h 0.23828 z m 0,0",
    id: "path1044"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,567.23828 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path1045"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 415.44141,567.23828 v -2.87891 h 0.23828 z m 0,0",
    id: "path1046"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,552.23828 0.23828,-2.87891 v 2.87891 z m 0,0",
    id: "path1047"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,552.23828 v -2.87891 h 0.23828 z m 0,0",
    id: "path1048"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,567.12109 0.23828,-2.88281 v 2.88281 z m 0,0",
    id: "path1049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 416.16016,567.12109 v -2.88281 h 0.23828 z m 0,0",
    id: "path1050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,552.60156 0.12109,-2.76172 v 2.76172 z m 0,0",
    id: "path1051"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,552.60156 v -2.76172 h 0.12109 z m 0,0",
    id: "path1052"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,566.64062 0.12109,-2.8789 v 2.8789 z m 0,0",
    id: "path1053"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417,566.64062 v -2.8789 h 0.12109 z m 0,0",
    id: "path1054"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,553.92187 0.11719,-2.88281 v 2.88281 z m 0,0",
    id: "path1055"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,553.92187 v -2.88281 h 0.11719 z m 0,0",
    id: "path1056"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,565.44141 0.11719,-2.88282 v 2.88282 z m 0,0",
    id: "path1057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 417.60156,565.44141 v -2.88282 h 0.11719 z m 0,0",
    id: "path1058"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,750.88021 v 3.83854 h 0.32292 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1059"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,752.16146 v 3.67709 h 0.31771 v -3.67709 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1060"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,752.47917 v 3.83854 h 0.31771 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1061"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,752.31771 v 3.84375 h 0.31771 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,751.6823 v 3.83854 h 0.16146 v -3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,750.07813 v 3.84375 h 0.15625 v -3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.83854,737.76042 v -3.83854 h 0.32292 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,736.47917 v -3.83854 h 0.31771 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1066"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.92187,736 v -3.68229 h 0.31771 V 736 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,736.31771 v -3.83854 h 0.31771 v 3.83854 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556,736.80209 v -3.68229 h 0.16146 v 3.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1069"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,738.5625 v -3.84375 h 0.15625 v 3.84375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1070"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 552.31771,704.16146 H 552 l -0.16146,0.15625 -0.15625,0.16146 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.31771,704.16146 h 0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,704.80209 v -0.32292 l -0.15625,-0.16146 -0.16146,-0.15625 h -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.4375,704.80209 v 1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,706.71875 h 0.31771 l 0.16146,-0.15625 0.15625,-0.16145 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.80208,706.71875 h -0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,706.07813 v 0.32292 l 0.15625,0.16145 0.16146,0.15625 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 551.68229,706.07813 v -1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,704.47917 -0.16146,0.16146 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.47917,704.47917 h 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1080"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,704.80209 -0.32292,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1081"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.28125,704.80209 v 1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1082"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,706.40105 0.32292,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1083"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.95833,706.5625 h -0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,706.07813 0.15625,0.16146 0.16146,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 552.16146,706.07813 v -1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1086"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,704.16146 h -0.31771 l -0.16146,0.15625 -0.16146,0.16146 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.71875,704.16146 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,704.80209 v -0.32292 l -0.15625,-0.16146 -0.16146,-0.15625 h -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1089"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.95833,704.80209 v 1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1090"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,706.71875 h 0.32291 l 0.16146,-0.15625 0.15625,-0.16145 v -0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1091"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.31771,706.71875 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,706.07813 v 0.32292 l 0.16146,0.16145 0.16146,0.15625 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.07812,706.07813 v -1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,704.47917 -0.16146,0.16146 -0.15625,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.88021,704.47917 h 1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1096"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,704.80209 -0.32291,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.80208,704.80209 v 1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1098"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,706.40105 0.32291,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 556.47917,706.5625 h -1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,706.07813 0.15625,0.16146 0.16146,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 554.5625,706.07813 v -1.27604 m 3.19792,84 -4.64063,-0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 550.71875,785.28125 0.32292,1.28125 0.3177,0.47917 0.64063,0.47917 0.47917,0.16146 0.64062,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 550.71875,785.28125 V 703.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 553.11979,700.80209 -0.64062,0.15625 -0.47917,0.16146 -0.64063,0.47916 -0.3177,0.47917 -0.32292,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.00210067 4.640422,-1.117691 M 4.95813,79.361476 H 4.640422 M 4.95813,7.517726 H 4.640422 m 0,80.484375 V -1.117691 M 4.95813,79.361476 V 7.517726 m -81.598958,2.401041 h 2.083333 m -0.802083,2.71875 h 0.802083",
    transform: "matrix(0.75,0,0,0.75,414.84,525.59999)",
    id: "path1106"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,5.33333e-6 -0.32251,-0.958328 -1.280843,-1.281245 -2.239177,-0.958328 -2.562093,5.33333e-6",
    transform: "matrix(0.75,0,0,0.75,358.32001,534)",
    id: "path1107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.00189733 0.320821,0.960231 0.799988,1.121689 1.279155,1.277939 1.758321,1.121689 2.237488,0.960231 2.560405,0.00189733",
    transform: "matrix(0.75,0,0,0.75,356.40001,583.43998)",
    id: "path1108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,5.33333e-6 V 46.401047 m 0,3.520833 v 9.4375 m 0,3.520834 V 65.92188 M 2.560405,5.33333e-6 V 46.401047 m 0,3.520833 v 9.4375 m 0,3.520834 v 3.041666 m 1.28125,10.880209 4.317708,-8 M 10.081238,65.281255 17.758321,51.35938 M 19.518738,48.000005 27.20103,34.07813 M 29.117696,30.562505 36.63853,16.64063 m 1.921875,-3.359375 7.520833,-13.921875",
    transform: "matrix(0.75,0,0,0.75,356.40001,534)",
    id: "path1109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,707.83855 4.48437,-8.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,0.002304 4.319366,8.158554 m 1.921875,3.520833 7.677083,13.921875 m 1.760417,3.359375 7.682292,13.921875 m 1.916666,3.515625 7.520834,13.921875 m 1.921875,3.359375 7.520833,13.921875",
    transform: "matrix(0.75,0,0,0.75,359.28001,524.75999)",
    id: "path1111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 523.19792,780.80209 4.48437,8",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,4.12e-4 0.958537,-0.161046 1.922078,-0.322505 2.880412,-0.801671 3.682495,-1.442296 4.317912,-2.239171 4.802287,-3.197505 4.958537,-4.161046 5.119995,-5.11938",
    transform: "matrix(0.75,0,0,0.75,563.16,712.32)",
    id: "path1113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 750.88021,949.92188 H 629.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.13333e-4,6.15333e-4 0.160645,0.958949 0.322103,1.92249 0.80127,2.880824 1.441895,3.677699 2.23877,4.318324 3.202312,4.79749 5.118978,5.120407",
    transform: "matrix(0.75,0,0,0.75,468.35998,708.48001)",
    id: "path1115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 624.31771,944.64063 V 796.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,-0.00148 -1.917684,0.321437 -2.881226,0.800603 -3.678101,1.441228 -4.318726,2.238103 -4.797893,3.201645 -5.120809,5.118312",
    transform: "matrix(0.75,0,0,0.75,472.19998,593.88002)",
    id: "path1117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 629.59896,791.6823 H 750.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,-0.00168333 -0.161458,-0.960017 -0.317708,-1.91835 -0.802083,-2.881892 -1.4375,-3.678767 -2.239583,-4.319392 -3.197917,-4.798558 -4.161458,-4.960017 -5.119792,-5.121475",
    transform: "matrix(0.75,0,0,0.75,567,597.72001)",
    id: "path1119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 756.16146,796.95834 V 944.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 750.88021,947.83855 0.80208,-0.15625 0.79688,-0.32292 0.64062,-0.47917 0.47917,-0.64062 0.32291,-0.80209 0.15625,-0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 750.88021,948 H 629.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 626.40104,944.64063 0.16146,0.79687 0.31771,0.80209 0.47916,0.64062 0.64063,0.47917 0.80208,0.32292 0.79688,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 626.40104,944.64063 V 796.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 629.59896,793.76042 -0.79688,0.16146 -0.80208,0.31771 -0.64063,0.47916 -0.47916,0.64063 -0.31771,0.80208 -0.16146,0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 629.59896,793.76042 H 750.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 754.07812,796.95834 -0.15625,-0.79688 -0.32291,-0.80208 -0.47917,-0.64063 -0.64062,-0.47916 -0.79688,-0.31771 -0.80208,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 754.23958,796.95834 V 944.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,0.00149067 1.921468,-0.159968 l 1.760417,-0.479166 1.760417,-0.958334 1.598958,-1.125 1.28125,-1.4375 0.958333,-1.598958 0.796875,-1.760417 0.322917,-1.921875 v -1.916666 l -0.322917,-1.921875 -0.796875,-1.760417 -0.958333,-1.598958 -1.28125,-1.442709 -1.598958,-1.119791 -1.760417,-0.958334 -1.760417,-0.479166 -1.921874667,-0.161459 -1.921875333,0.161459 -1.755208,0.479166 -1.760417,0.958334 -1.604166,1.119791 -1.276042,1.442709 -0.963542,1.598958 -0.796875,1.760417 -0.322916,1.921875 v 1.916666 l 0.322916,1.921875 0.796875,1.760417 0.963542,1.598958 1.276042,1.4375 1.604166,1.125 1.760417,0.958334 1.755208,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,517.67999,660.11998)",
    id: "path1129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00229333 1.442302,-0.158543 l 1.4375,-0.479167 1.28125,-0.802083 0.958333,-0.958334 0.802083,-1.28125 0.479167,-1.442708 0.161458,-1.4375 -0.161458,-1.442708 -0.479167,-1.4375 -0.802083,-1.28125 -0.958333,-0.958334 -1.28125,-0.802083 -1.4375,-0.479167 -1.442708667,-0.161458 -1.437500333,0.161458 -1.442708,0.479167 -1.28125,0.802083 -0.958333,0.958334 -0.802084,1.28125 -0.479166,1.4375 -0.15625,1.442708 0.15625,1.4375 0.479166,1.442708 0.802084,1.28125 0.958333,0.958334 1.28125,0.802083 1.442708,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,517.67999,657.24)",
    id: "path1130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-8.08e-4 H -127.83895 M -4.06667e-4,-1.917475 H -127.83895 M -4.06667e-4,68.639817 H -127.83895 M -4.06667e-4,70.561692 H -127.83895",
    transform: "matrix(0.75,0,0,0.75,565.67999,627.35998)",
    id: "path1131"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1131"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 530.63641,
    y: 633.84094,
    id: "use1131"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1132"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 530.63641,
    y: 641.56891,
    id: "use1132"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1133"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 530.63641,
    y: 649.15887,
    id: "use1133"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1134"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 530.63641,
    y: 656.88678,
    id: "use1134"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1135"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 530.63641,
    y: 664.61475,
    id: "use1135"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00148533,5.33333e-6 0.959819,-0.161453 1.918152,-0.317703 2.881694,-0.802078 3.678569,-1.437495 4.319194,-2.239578 4.79836,-3.197911 4.959819,-4.161453 5.121277,-5.119786",
    transform: "matrix(0.75,0,0,0.75,447.11998,711)",
    id: "path1135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 596.16146,948.16146 H 474.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,2.08667e-4 0.160411,0.958542 0.321869,1.922084 0.801036,2.880417 1.441661,3.6825 2.238536,4.317917 3.202077,4.802292 4.160411,4.958542 5.118744,5.12",
    transform: "matrix(0.75,0,0,0.75,352.2,707.16)",
    id: "path1137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 469.4375,942.88021 V 795.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,0.00189733 -0.959584,0.158147 -1.917918,0.319606 -2.881459,0.798772 -3.678334,1.439397 -4.318959,2.241481 -4.798126,3.199814 -4.959584,4.158147 -5.121043,5.121689",
    transform: "matrix(0.75,0,0,0.75,356.04,592.43998)",
    id: "path1139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 474.71875,789.76042 H 596.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001221,0.001694 -0.161458,-0.963542 -0.161459,-0.958333 -0.479166,-0.958333 -0.640625,-0.802084 -0.796875,-0.640625 -0.963542,-0.479166 -0.958333,-0.161459 -0.958334,-0.15625",
    transform: "matrix(0.75,0,0,0.75,450.96002,596.27998)",
    id: "path1141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 601.4375,795.04167 V 942.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 596.16146,946.07813 0.79687,-0.15625 0.80209,-0.32292 0.64062,-0.47916 0.47917,-0.64063 0.31771,-0.79687 0.16145,-0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 596.16146,946.07813 H 474.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.52083,942.88021 0.16146,0.80209 0.31771,0.79687 0.47917,0.64063 0.64062,0.47916 0.80208,0.32292 0.79688,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.52083,942.88021 V 795.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 474.71875,791.83855 473.92187,792 l -0.80208,0.31771 -0.64062,0.48438 -0.47917,0.63541 -0.31771,0.80209 -0.16146,0.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 474.71875,791.83855 H 596.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 599.35937,795.04167 -0.16145,-0.80208 -0.31771,-0.80209 -0.47917,-0.63541 -0.64062,-0.48438 -0.80209,-0.31771 -0.79687,-0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 599.35937,795.04167 V 942.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.13333e-4,-4.01333e-4 1.91748,-0.16186 3.677897,-0.641026 5.438313,-1.59936 7.04248,-2.719151 8.318522,-4.16186 l 0.963541,-1.598958 0.796875,-1.760417 0.322917,-1.916666 v -1.921875 l -0.322917,-1.921875 -0.796875,-1.760417 -0.963541,-1.598958 -1.276042,-1.4375 -1.604167,-1.119792 -1.760416,-0.963542 -1.760417,-0.479166 -1.916666667,-0.161459 -1.921875333,0.161459 -1.760416,0.479166 -1.760417,0.963542 -1.598958,1.119792 -1.28125,1.4375 -0.958334,1.598958 -0.802083,1.760417 -0.317708,1.921875 v 1.921875 l 0.317708,1.916666 0.802083,1.760417 0.958334,1.598958 1.28125,1.442709 1.598958,1.119791 1.760417,0.958334 1.760416,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,401.64001,658.67999)",
    id: "path1151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.13333e-4,0.001023 1.438313,-0.160435 l 1.442709,-0.479167 1.28125,-0.802083 0.958333,-0.958334 0.796875,-1.28125 0.484375,-1.4375 0.15625,-1.442708 -0.15625,-1.4375 -0.484375,-1.442708 -0.796875,-1.276042 -0.958333,-0.963542 -1.28125,-0.796875 -1.442709,-0.484375 -1.437499667,-0.15625 -1.442708333,0.15625 -1.4375,0.484375 -1.28125,0.796875 -0.958333,0.963542 -0.802084,1.276042 -0.479166,1.442708 -0.161459,1.4375 0.161459,1.442708 0.479166,1.4375 0.802084,1.28125 0.958333,0.958334 1.28125,0.802083 1.4375,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,401.64001,655.80001)",
    id: "path1152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-0.00121567 H -127.83915 M -6.1e-4,-2.079341 H -127.83915 M -6.1e-4,68.477951 H -127.83915 M -6.1e-4,70.561284 h -127.83854",
    transform: "matrix(0.75,0,0,0.75,449.51999,626.03997)",
    id: "path1153"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1153"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 414.47586,
    y: 632.39642,
    id: "use1153"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1154"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 414.47586,
    y: 640.12439,
    id: "use1154"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1155"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 414.47586,
    y: 647.71436,
    id: "use1155"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1156"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 414.47586,
    y: 655.44232,
    id: "use1156"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1157"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 414.47586,
    y: 663.17023,
    id: "use1157"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 754.07812,182.71875 v 52.80209 h -65.91666 v -52.80209 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 688.16146,182.71875 v 52.80209 h -65.92188 v -52.80209 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1158"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/план_пральня.e6f28d53c05b3de519548426e5aab1f8.svg";
export { ForwardRef as ReactComponent };